{
  "contractName": "StakerFactory",
  "abi": [
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "_token",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "_user",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "_amount",
          "type": "uint256"
        }
      ],
      "name": "FacetTokensToUser",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "_stakeAddress",
          "type": "address"
        }
      ],
      "name": "FarmAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "previousOwner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "OwnershipTransferred",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "FAUCET_AMOUNT",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "FAUCET_TIME",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "farms",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "faucetTimes",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "owner",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [],
      "name": "renounceOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalFarms",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newOwner",
          "type": "address"
        }
      ],
      "name": "transferOwnership",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_tokenA",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_tokenB",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "startTime",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "endTime",
          "type": "uint256"
        }
      ],
      "name": "createFarm",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getFarms",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "farm",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "stake",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "reward",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "startTime",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "endTime",
              "type": "uint256"
            }
          ],
          "internalType": "struct StakerFactory.Farm[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function",
      "constant": true
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "_tokenAddr",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "_user",
          "type": "address"
        }
      ],
      "name": "faucetTokens",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    }
  ],
  "metadata": "{\"compiler\":{\"version\":\"0.8.7+commit.e28d00a7\"},\"language\":\"Solidity\",\"output\":{\"abi\":[{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_token\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_user\",\"type\":\"address\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_amount\",\"type\":\"uint256\"}],\"name\":\"FacetTokensToUser\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_stakeAddress\",\"type\":\"address\"}],\"name\":\"FarmAdded\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"previousOwner\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"OwnershipTransferred\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"FAUCET_AMOUNT\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"FAUCET_TIME\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_tokenA\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_tokenB\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"startTime\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"endTime\",\"type\":\"uint256\"}],\"name\":\"createFarm\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"name\":\"farms\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"name\":\"faucetTimes\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_tokenAddr\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_user\",\"type\":\"address\"}],\"name\":\"faucetTokens\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"getFarms\",\"outputs\":[{\"components\":[{\"internalType\":\"address\",\"name\":\"farm\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"stake\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"reward\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"startTime\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"endTime\",\"type\":\"uint256\"}],\"internalType\":\"struct StakerFactory.Farm[]\",\"name\":\"\",\"type\":\"tuple[]\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"owner\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"renounceOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"totalFarms\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"newOwner\",\"type\":\"address\"}],\"name\":\"transferOwnership\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"devdoc\":{\"kind\":\"dev\",\"methods\":{\"owner()\":{\"details\":\"Returns the address of the current owner.\"},\"renounceOwnership()\":{\"details\":\"Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner.\"},\"transferOwnership(address)\":{\"details\":\"Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner.\"}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{},\"version\":1}},\"settings\":{\"compilationTarget\":{\"project:/contracts/StakerFactory.sol\":\"StakerFactory\"},\"evmVersion\":\"byzantium\",\"libraries\":{},\"metadata\":{\"bytecodeHash\":\"ipfs\"},\"optimizer\":{\"enabled\":false,\"runs\":200},\"remappings\":[]},\"sources\":{\"@openzeppelin/contracts/access/Ownable.sol\":{\"keccak256\":\"0x6bb804a310218875e89d12c053e94a13a4607cdf7cc2052f3e52bd32a0dc50a1\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://b2ebbbe6d0011175bd9e7268b83de3f9c2f9d8d4cbfbaef12aff977d7d727163\",\"dweb:/ipfs/Qmd5c7Vxtis9wzkDNhxwc6A2QT5H9xn9kfjhx7qx44vpro\"]},\"@openzeppelin/contracts/token/ERC20/IERC20.sol\":{\"keccak256\":\"0x027b891937d20ccf213fdb9c31531574256de774bda99d3a70ecef6e1913ed2a\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://087318b21c528119f649899f5b5580566dd8d7b0303d4904bd0e8580c3545f14\",\"dweb:/ipfs/Qmbn5Mj7aUn8hJuQ8VrQjjEXRsXyJKykgnjR9p4C3nfLtL\"]},\"@openzeppelin/contracts/utils/Context.sol\":{\"keccak256\":\"0x90565a39ae45c80f0468dc96c7b20d0afc3055f344c8203a0c9258239f350b9f\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://26e8b38a7ac8e7b4463af00cf7fff1bf48ae9875765bf4f7751e100124d0bc8c\",\"dweb:/ipfs/QmWcsmkVr24xmmjfnBQZoemFniXjj3vwT78Cz6uqZW1Hux\"]},\"@openzeppelin/contracts/utils/math/SafeMath.sol\":{\"keccak256\":\"0x8666f020bd8fc9dc14f07e2ebc52b5f236ab4cdde7c77679b08cb2f94730043b\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://163776cbf565c722232393aa2d62cbe8a2ffb5805986abf4906c00e1e07450a6\",\"dweb:/ipfs/QmPZoN9T3cb6o8bGhjBPZcz7im8T8DWhpr3tjLwhJJHx9N\"]},\"project:/contracts/IToken.sol\":{\"keccak256\":\"0xb1953d0e3a2745426b36c4849fc96bc1c27b5325d64c247f7ee99429d54ad563\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://85e669e9238064d833f85a88b81aacd2b8e2a425ac552cf467652aa3967a8f19\",\"dweb:/ipfs/QmXQx1fuk37D2JzaMEaimeCGSJpDSpZ21GP6qJHem19bZZ\"]},\"project:/contracts/Staker.sol\":{\"keccak256\":\"0xbef7e5608990427e3f0e3eed57df3cd03c84b5603e9f351b91577175921fbe15\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://43f4a2d3c1bb96a2b190c9cdfbf44ed982ae6cd1add52406dc79e23a2c4163f1\",\"dweb:/ipfs/QmZHqtUWKcnUoTAH6xUwzkHzKQrj3nHb1LFnfHCfrFKi7s\"]},\"project:/contracts/StakerFactory.sol\":{\"keccak256\":\"0x3d7f3f81b661816a0055079f5b73c98dc55d7d4764e682c871880a619d086ff1\",\"license\":\"MIT\",\"urls\":[\"bzz-raw://99d15025d6499370af2f31b2fe3845121f8a77bab0d4606a278e81f2d63b6538\",\"dweb:/ipfs/QmW3E71GnHGp1PWworynpBGEXJwgQzwciQdHzKBMUXJcy2\"]}},\"version\":1}",
  "bytecode": "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",
  "deployedBytecode": "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",
  "immutableReferences": {},
  "generatedSources": [],
  "deployedGeneratedSources": [
    {
      "ast": {
        "nodeType": "YulBlock",
        "src": "0:14726:17",
        "statements": [
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "59:87:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "69:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "91:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "78:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "78:20:17"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "69:5:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "134:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_t_address",
                      "nodeType": "YulIdentifier",
                      "src": "107:26:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "107:33:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "107:33:17"
                }
              ]
            },
            "name": "abi_decode_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "37:6:17",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "45:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "53:5:17",
                "type": ""
              }
            ],
            "src": "7:139:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "215:80:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "225:22:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "240:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "234:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "234:13:17"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "225:5:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "283:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_t_address",
                      "nodeType": "YulIdentifier",
                      "src": "256:26:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "256:33:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "256:33:17"
                }
              ]
            },
            "name": "abi_decode_t_address_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "193:6:17",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "201:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "209:5:17",
                "type": ""
              }
            ],
            "src": "152:143:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "353:87:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "363:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "385:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "calldataload",
                      "nodeType": "YulIdentifier",
                      "src": "372:12:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "372:20:17"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "363:5:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "428:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_t_uint256",
                      "nodeType": "YulIdentifier",
                      "src": "401:26:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "401:33:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "401:33:17"
                }
              ]
            },
            "name": "abi_decode_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "331:6:17",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "339:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "347:5:17",
                "type": ""
              }
            ],
            "src": "301:139:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "509:80:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "519:22:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "offset",
                        "nodeType": "YulIdentifier",
                        "src": "534:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "528:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "528:13:17"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "519:5:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "577:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "validator_revert_t_uint256",
                      "nodeType": "YulIdentifier",
                      "src": "550:26:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "550:33:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "550:33:17"
                }
              ]
            },
            "name": "abi_decode_t_uint256_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "offset",
                "nodeType": "YulTypedName",
                "src": "487:6:17",
                "type": ""
              },
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "495:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "503:5:17",
                "type": ""
              }
            ],
            "src": "446:143:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "661:263:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "707:83:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "709:77:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "709:79:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "709:79:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "682:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "691:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "678:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "678:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "703:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "674:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "674:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "671:119:17"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "800:117:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "815:15:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "829:1:17",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "819:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "844:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "879:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "890:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "875:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "875:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "899:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "854:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "854:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "844:6:17"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "631:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "642:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "654:6:17",
                "type": ""
              }
            ],
            "src": "595:329:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1007:274:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1053:83:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "1055:77:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1055:79:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1055:79:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1028:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1037:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1024:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1024:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1049:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1020:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1020:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1017:119:17"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "1146:128:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "1161:15:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1175:1:17",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "1165:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "1190:74:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "1236:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "1247:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "1232:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1232:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1256:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_address_fromMemory",
                          "nodeType": "YulIdentifier",
                          "src": "1200:31:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1200:64:17"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "1190:6:17"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_address_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "977:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "988:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1000:6:17",
                "type": ""
              }
            ],
            "src": "930:351:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1370:391:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1416:83:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "1418:77:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1418:79:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1418:79:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1391:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1400:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1387:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1387:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1412:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1383:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1383:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1380:119:17"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "1509:117:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "1524:15:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1538:1:17",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "1528:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "1553:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "1588:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "1599:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "1584:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1584:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1608:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "1563:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1563:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "1553:6:17"
                        }
                      ]
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "1636:118:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "1651:16:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1665:2:17",
                        "type": "",
                        "value": "32"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "1655:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "1681:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "1716:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "1727:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "1712:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "1712:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1736:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "1691:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1691:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value1",
                          "nodeType": "YulIdentifier",
                          "src": "1681:6:17"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1332:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1343:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1355:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "1363:6:17",
                "type": ""
              }
            ],
            "src": "1287:474:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "1884:648:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "1931:83:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "1933:77:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "1933:79:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "1933:79:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "1905:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "1914:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "1901:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "1901:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "1926:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "1897:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "1897:33:17"
                  },
                  "nodeType": "YulIf",
                  "src": "1894:120:17"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "2024:117:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "2039:15:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2053:1:17",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "2043:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "2068:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "2103:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "2114:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "2099:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "2099:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2123:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "2078:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2078:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "2068:6:17"
                        }
                      ]
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "2151:118:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "2166:16:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2180:2:17",
                        "type": "",
                        "value": "32"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "2170:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "2196:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "2231:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "2242:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "2227:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "2227:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2251:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "2206:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2206:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value1",
                          "nodeType": "YulIdentifier",
                          "src": "2196:6:17"
                        }
                      ]
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "2279:118:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "2294:16:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2308:2:17",
                        "type": "",
                        "value": "64"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "2298:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "2324:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "2359:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "2370:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "2355:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "2355:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2379:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_uint256",
                          "nodeType": "YulIdentifier",
                          "src": "2334:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2334:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value2",
                          "nodeType": "YulIdentifier",
                          "src": "2324:6:17"
                        }
                      ]
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "2407:118:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "2422:16:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2436:2:17",
                        "type": "",
                        "value": "96"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "2426:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "2452:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "2487:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "2498:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "2483:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "2483:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2507:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_uint256",
                          "nodeType": "YulIdentifier",
                          "src": "2462:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2462:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value3",
                          "nodeType": "YulIdentifier",
                          "src": "2452:6:17"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_addresst_addresst_uint256t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "1830:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "1841:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "1853:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "1861:6:17",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "1869:6:17",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "1877:6:17",
                "type": ""
              }
            ],
            "src": "1767:765:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2604:263:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2650:83:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "2652:77:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2652:79:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2652:79:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2625:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2634:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2621:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2621:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2646:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2617:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2617:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "2614:119:17"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "2743:117:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "2758:15:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2772:1:17",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "2762:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "2787:63:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "2822:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "2833:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "2818:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "2818:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2842:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_uint256",
                          "nodeType": "YulIdentifier",
                          "src": "2797:20:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2797:53:17"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "2787:6:17"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2574:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "2585:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2597:6:17",
                "type": ""
              }
            ],
            "src": "2538:329:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "2950:274:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "2996:83:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
                            "nodeType": "YulIdentifier",
                            "src": "2998:77:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "2998:79:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "2998:79:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "2971:7:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "2980:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "2967:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "2967:23:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "2992:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "slt",
                      "nodeType": "YulIdentifier",
                      "src": "2963:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "2963:32:17"
                  },
                  "nodeType": "YulIf",
                  "src": "2960:119:17"
                },
                {
                  "nodeType": "YulBlock",
                  "src": "3089:128:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "3104:15:17",
                      "value": {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3118:1:17",
                        "type": "",
                        "value": "0"
                      },
                      "variables": [
                        {
                          "name": "offset",
                          "nodeType": "YulTypedName",
                          "src": "3108:6:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "nodeType": "YulAssignment",
                      "src": "3133:74:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "headStart",
                                "nodeType": "YulIdentifier",
                                "src": "3179:9:17"
                              },
                              {
                                "name": "offset",
                                "nodeType": "YulIdentifier",
                                "src": "3190:6:17"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "3175:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "3175:22:17"
                          },
                          {
                            "name": "dataEnd",
                            "nodeType": "YulIdentifier",
                            "src": "3199:7:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_decode_t_uint256_fromMemory",
                          "nodeType": "YulIdentifier",
                          "src": "3143:31:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3143:64:17"
                      },
                      "variableNames": [
                        {
                          "name": "value0",
                          "nodeType": "YulIdentifier",
                          "src": "3133:6:17"
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            "name": "abi_decode_tuple_t_uint256_fromMemory",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "2920:9:17",
                "type": ""
              },
              {
                "name": "dataEnd",
                "nodeType": "YulTypedName",
                "src": "2931:7:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "2943:6:17",
                "type": ""
              }
            ],
            "src": "2873:351:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3354:143:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "3442:6:17"
                      },
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3450:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr",
                      "nodeType": "YulIdentifier",
                      "src": "3364:77:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3364:90:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3364:90:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "3463:28:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3481:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "3486:4:17",
                        "type": "",
                        "value": "0xa0"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "3477:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3477:14:17"
                  },
                  "variableNames": [
                    {
                      "name": "updatedPos",
                      "nodeType": "YulIdentifier",
                      "src": "3463:10:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encodeUpdatedPos_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "3327:6:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "3335:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "updatedPos",
                "nodeType": "YulTypedName",
                "src": "3343:10:17",
                "type": ""
              }
            ],
            "src": "3230:267:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3558:53:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3575:3:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "3598:5:17"
                          }
                        ],
                        "functionName": {
                          "name": "cleanup_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "3580:17:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3580:24:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3568:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3568:37:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3568:37:17"
                }
              ]
            },
            "name": "abi_encode_t_address_to_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "3546:5:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "3553:3:17",
                "type": ""
              }
            ],
            "src": "3503:108:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3682:53:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "3699:3:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "3722:5:17"
                          }
                        ],
                        "functionName": {
                          "name": "cleanup_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "3704:17:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "3704:24:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "3692:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3692:37:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "3692:37:17"
                }
              ]
            },
            "name": "abi_encode_t_address_to_t_address_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "3670:5:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "3677:3:17",
                "type": ""
              }
            ],
            "src": "3617:118:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "3975:740:17",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "3985:90:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "4069:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "array_length_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                      "nodeType": "YulIdentifier",
                      "src": "3999:69:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "3999:76:17"
                  },
                  "variables": [
                    {
                      "name": "length",
                      "nodeType": "YulTypedName",
                      "src": "3989:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4084:115:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "4187:3:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "4192:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "array_storeLengthForEncoding_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "4091:95:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4091:108:17"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "4084:3:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "4208:93:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "4295:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "array_dataslot_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                      "nodeType": "YulIdentifier",
                      "src": "4223:71:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4223:78:17"
                  },
                  "variables": [
                    {
                      "name": "baseRef",
                      "nodeType": "YulTypedName",
                      "src": "4212:7:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "4310:21:17",
                  "value": {
                    "name": "baseRef",
                    "nodeType": "YulIdentifier",
                    "src": "4324:7:17"
                  },
                  "variables": [
                    {
                      "name": "srcPtr",
                      "nodeType": "YulTypedName",
                      "src": "4314:6:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "4400:290:17",
                    "statements": [
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "4414:34:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "srcPtr",
                              "nodeType": "YulIdentifier",
                              "src": "4441:6:17"
                            }
                          ],
                          "functionName": {
                            "name": "mload",
                            "nodeType": "YulIdentifier",
                            "src": "4435:5:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4435:13:17"
                        },
                        "variables": [
                          {
                            "name": "elementValue0",
                            "nodeType": "YulTypedName",
                            "src": "4418:13:17",
                            "type": ""
                          }
                        ]
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "4461:114:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "elementValue0",
                              "nodeType": "YulIdentifier",
                              "src": "4556:13:17"
                            },
                            {
                              "name": "pos",
                              "nodeType": "YulIdentifier",
                              "src": "4571:3:17"
                            }
                          ],
                          "functionName": {
                            "name": "abi_encodeUpdatedPos_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr",
                            "nodeType": "YulIdentifier",
                            "src": "4468:87:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4468:107:17"
                        },
                        "variableNames": [
                          {
                            "name": "pos",
                            "nodeType": "YulIdentifier",
                            "src": "4461:3:17"
                          }
                        ]
                      },
                      {
                        "nodeType": "YulAssignment",
                        "src": "4588:92:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "srcPtr",
                              "nodeType": "YulIdentifier",
                              "src": "4673:6:17"
                            }
                          ],
                          "functionName": {
                            "name": "array_nextElement_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                            "nodeType": "YulIdentifier",
                            "src": "4598:74:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4598:82:17"
                        },
                        "variableNames": [
                          {
                            "name": "srcPtr",
                            "nodeType": "YulIdentifier",
                            "src": "4588:6:17"
                          }
                        ]
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "i",
                        "nodeType": "YulIdentifier",
                        "src": "4362:1:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "4365:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "lt",
                      "nodeType": "YulIdentifier",
                      "src": "4359:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4359:13:17"
                  },
                  "nodeType": "YulForLoop",
                  "post": {
                    "nodeType": "YulBlock",
                    "src": "4373:18:17",
                    "statements": [
                      {
                        "nodeType": "YulAssignment",
                        "src": "4375:14:17",
                        "value": {
                          "arguments": [
                            {
                              "name": "i",
                              "nodeType": "YulIdentifier",
                              "src": "4384:1:17"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "4387:1:17",
                              "type": "",
                              "value": "1"
                            }
                          ],
                          "functionName": {
                            "name": "add",
                            "nodeType": "YulIdentifier",
                            "src": "4380:3:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "4380:9:17"
                        },
                        "variableNames": [
                          {
                            "name": "i",
                            "nodeType": "YulIdentifier",
                            "src": "4375:1:17"
                          }
                        ]
                      }
                    ]
                  },
                  "pre": {
                    "nodeType": "YulBlock",
                    "src": "4344:14:17",
                    "statements": [
                      {
                        "nodeType": "YulVariableDeclaration",
                        "src": "4346:10:17",
                        "value": {
                          "kind": "number",
                          "nodeType": "YulLiteral",
                          "src": "4355:1:17",
                          "type": "",
                          "value": "0"
                        },
                        "variables": [
                          {
                            "name": "i",
                            "nodeType": "YulTypedName",
                            "src": "4350:1:17",
                            "type": ""
                          }
                        ]
                      }
                    ]
                  },
                  "src": "4340:350:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "4699:10:17",
                  "value": {
                    "name": "pos",
                    "nodeType": "YulIdentifier",
                    "src": "4706:3:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "4699:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "3954:5:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "3961:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "3970:3:17",
                "type": ""
              }
            ],
            "src": "3807:908:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "4867:220:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "4877:74:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "4943:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "4948:2:17",
                        "type": "",
                        "value": "38"
                      }
                    ],
                    "functionName": {
                      "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "4884:58:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4884:67:17"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "4877:3:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5049:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe",
                      "nodeType": "YulIdentifier",
                      "src": "4960:88:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "4960:93:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "4960:93:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5062:19:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5073:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5078:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "5069:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5069:12:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "5062:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "4855:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "4863:3:17",
                "type": ""
              }
            ],
            "src": "4721:366:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "5239:220:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "5249:74:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5315:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5320:2:17",
                        "type": "",
                        "value": "34"
                      }
                    ],
                    "functionName": {
                      "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "5256:58:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5256:67:17"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "5249:3:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5421:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "store_literal_in_memory_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec",
                      "nodeType": "YulIdentifier",
                      "src": "5332:88:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5332:93:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "5332:93:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5434:19:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5445:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5450:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "5441:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5441:12:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "5434:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec_to_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "5227:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "5235:3:17",
                "type": ""
              }
            ],
            "src": "5093:366:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "5611:220:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "5621:74:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5687:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5692:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "5628:58:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5628:67:17"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "5621:3:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5793:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe",
                      "nodeType": "YulIdentifier",
                      "src": "5704:88:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5704:93:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "5704:93:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "5806:19:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "5817:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "5822:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "5813:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "5813:12:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "5806:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "5599:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "5607:3:17",
                "type": ""
              }
            ],
            "src": "5465:366:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "5983:220:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "5993:74:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "6059:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "6064:2:17",
                        "type": "",
                        "value": "30"
                      }
                    ],
                    "functionName": {
                      "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "6000:58:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6000:67:17"
                  },
                  "variableNames": [
                    {
                      "name": "pos",
                      "nodeType": "YulIdentifier",
                      "src": "5993:3:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "6165:3:17"
                      }
                    ],
                    "functionName": {
                      "name": "store_literal_in_memory_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c",
                      "nodeType": "YulIdentifier",
                      "src": "6076:88:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6076:93:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "6076:93:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "6178:19:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "6189:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "6194:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "6185:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6185:12:17"
                  },
                  "variableNames": [
                    {
                      "name": "end",
                      "nodeType": "YulIdentifier",
                      "src": "6178:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c_to_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "5971:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "end",
                "nodeType": "YulTypedName",
                "src": "5979:3:17",
                "type": ""
              }
            ],
            "src": "5837:366:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "6371:924:17",
              "statements": [
                {
                  "nodeType": "YulVariableDeclaration",
                  "src": "6381:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "6397:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "6402:4:17",
                        "type": "",
                        "value": "0xa0"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "6393:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "6393:14:17"
                  },
                  "variables": [
                    {
                      "name": "tail",
                      "nodeType": "YulTypedName",
                      "src": "6385:4:17",
                      "type": ""
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "6417:164:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "6452:43:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "6482:5:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "6489:4:17",
                                "type": "",
                                "value": "0x00"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "6478:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "6478:16:17"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "6472:5:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6472:23:17"
                      },
                      "variables": [
                        {
                          "name": "memberValue0",
                          "nodeType": "YulTypedName",
                          "src": "6456:12:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "expression": {
                        "arguments": [
                          {
                            "name": "memberValue0",
                            "nodeType": "YulIdentifier",
                            "src": "6542:12:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "pos",
                                "nodeType": "YulIdentifier",
                                "src": "6560:3:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "6565:4:17",
                                "type": "",
                                "value": "0x00"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "6556:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "6556:14:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_encode_t_address_to_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "6508:33:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6508:63:17"
                      },
                      "nodeType": "YulExpressionStatement",
                      "src": "6508:63:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "6591:165:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "6627:43:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "6657:5:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "6664:4:17",
                                "type": "",
                                "value": "0x20"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "6653:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "6653:16:17"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "6647:5:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6647:23:17"
                      },
                      "variables": [
                        {
                          "name": "memberValue0",
                          "nodeType": "YulTypedName",
                          "src": "6631:12:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "expression": {
                        "arguments": [
                          {
                            "name": "memberValue0",
                            "nodeType": "YulIdentifier",
                            "src": "6717:12:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "pos",
                                "nodeType": "YulIdentifier",
                                "src": "6735:3:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "6740:4:17",
                                "type": "",
                                "value": "0x20"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "6731:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "6731:14:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_encode_t_address_to_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "6683:33:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6683:63:17"
                      },
                      "nodeType": "YulExpressionStatement",
                      "src": "6683:63:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "6766:166:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "6803:43:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "6833:5:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "6840:4:17",
                                "type": "",
                                "value": "0x40"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "6829:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "6829:16:17"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "6823:5:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6823:23:17"
                      },
                      "variables": [
                        {
                          "name": "memberValue0",
                          "nodeType": "YulTypedName",
                          "src": "6807:12:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "expression": {
                        "arguments": [
                          {
                            "name": "memberValue0",
                            "nodeType": "YulIdentifier",
                            "src": "6893:12:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "pos",
                                "nodeType": "YulIdentifier",
                                "src": "6911:3:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "6916:4:17",
                                "type": "",
                                "value": "0x40"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "6907:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "6907:14:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_encode_t_address_to_t_address",
                          "nodeType": "YulIdentifier",
                          "src": "6859:33:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "6859:63:17"
                      },
                      "nodeType": "YulExpressionStatement",
                      "src": "6859:63:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "6942:169:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "6982:43:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "7012:5:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "7019:4:17",
                                "type": "",
                                "value": "0x60"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "7008:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "7008:16:17"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "7002:5:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7002:23:17"
                      },
                      "variables": [
                        {
                          "name": "memberValue0",
                          "nodeType": "YulTypedName",
                          "src": "6986:12:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "expression": {
                        "arguments": [
                          {
                            "name": "memberValue0",
                            "nodeType": "YulIdentifier",
                            "src": "7072:12:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "pos",
                                "nodeType": "YulIdentifier",
                                "src": "7090:3:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "7095:4:17",
                                "type": "",
                                "value": "0x60"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "7086:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "7086:14:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_encode_t_uint256_to_t_uint256",
                          "nodeType": "YulIdentifier",
                          "src": "7038:33:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7038:63:17"
                      },
                      "nodeType": "YulExpressionStatement",
                      "src": "7038:63:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulBlock",
                  "src": "7121:167:17",
                  "statements": [
                    {
                      "nodeType": "YulVariableDeclaration",
                      "src": "7159:43:17",
                      "value": {
                        "arguments": [
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "7189:5:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "7196:4:17",
                                "type": "",
                                "value": "0x80"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "7185:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "7185:16:17"
                          }
                        ],
                        "functionName": {
                          "name": "mload",
                          "nodeType": "YulIdentifier",
                          "src": "7179:5:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7179:23:17"
                      },
                      "variables": [
                        {
                          "name": "memberValue0",
                          "nodeType": "YulTypedName",
                          "src": "7163:12:17",
                          "type": ""
                        }
                      ]
                    },
                    {
                      "expression": {
                        "arguments": [
                          {
                            "name": "memberValue0",
                            "nodeType": "YulIdentifier",
                            "src": "7249:12:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "pos",
                                "nodeType": "YulIdentifier",
                                "src": "7267:3:17"
                              },
                              {
                                "kind": "number",
                                "nodeType": "YulLiteral",
                                "src": "7272:4:17",
                                "type": "",
                                "value": "0x80"
                              }
                            ],
                            "functionName": {
                              "name": "add",
                              "nodeType": "YulIdentifier",
                              "src": "7263:3:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "7263:14:17"
                          }
                        ],
                        "functionName": {
                          "name": "abi_encode_t_uint256_to_t_uint256",
                          "nodeType": "YulIdentifier",
                          "src": "7215:33:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7215:63:17"
                      },
                      "nodeType": "YulExpressionStatement",
                      "src": "7215:63:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "6358:5:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "6365:3:17",
                "type": ""
              }
            ],
            "src": "6271:1024:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7356:53:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "7373:3:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "7396:5:17"
                          }
                        ],
                        "functionName": {
                          "name": "cleanup_t_uint256",
                          "nodeType": "YulIdentifier",
                          "src": "7378:17:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7378:24:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7366:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7366:37:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7366:37:17"
                }
              ]
            },
            "name": "abi_encode_t_uint256_to_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "7344:5:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "7351:3:17",
                "type": ""
              }
            ],
            "src": "7301:108:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7480:53:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "7497:3:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "7520:5:17"
                          }
                        ],
                        "functionName": {
                          "name": "cleanup_t_uint256",
                          "nodeType": "YulIdentifier",
                          "src": "7502:17:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7502:24:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "7490:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7490:37:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7490:37:17"
                }
              ]
            },
            "name": "abi_encode_t_uint256_to_t_uint256_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "7468:5:17",
                "type": ""
              },
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "7475:3:17",
                "type": ""
              }
            ],
            "src": "7415:118:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7637:124:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "7647:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "7659:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7670:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "7655:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7655:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "7647:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "7727:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "7740:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "7751:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "7736:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "7736:17:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_address_to_t_address_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "7683:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7683:71:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7683:71:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address__to_t_address__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "7609:9:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "7621:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "7632:4:17",
                "type": ""
              }
            ],
            "src": "7539:222:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "7949:371:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "7959:27:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "7971:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "7982:3:17",
                        "type": "",
                        "value": "128"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "7967:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7967:19:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "7959:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "8040:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8053:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8064:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8049:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8049:17:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_address_to_t_address_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "7996:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "7996:71:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "7996:71:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "8121:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8134:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8145:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8130:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8130:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_address_to_t_address_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "8077:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8077:72:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8077:72:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value2",
                        "nodeType": "YulIdentifier",
                        "src": "8203:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8216:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8227:2:17",
                            "type": "",
                            "value": "64"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8212:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8212:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_uint256_to_t_uint256_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "8159:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8159:72:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8159:72:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value3",
                        "nodeType": "YulIdentifier",
                        "src": "8285:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8298:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8309:2:17",
                            "type": "",
                            "value": "96"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8294:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8294:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_uint256_to_t_uint256_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "8241:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8241:72:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8241:72:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address_t_address_t_uint256_t_uint256__to_t_address_t_address_t_uint256_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "7897:9:17",
                "type": ""
              },
              {
                "name": "value3",
                "nodeType": "YulTypedName",
                "src": "7909:6:17",
                "type": ""
              },
              {
                "name": "value2",
                "nodeType": "YulTypedName",
                "src": "7917:6:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "7925:6:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "7933:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "7944:4:17",
                "type": ""
              }
            ],
            "src": "7767:553:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8452:206:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "8462:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8474:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8485:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "8470:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8470:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8462:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "8542:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8555:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8566:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8551:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8551:17:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_address_to_t_address_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "8498:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8498:71:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8498:71:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value1",
                        "nodeType": "YulIdentifier",
                        "src": "8623:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8636:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8647:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8632:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8632:18:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_uint256_to_t_uint256_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "8579:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8579:72:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8579:72:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_address_t_uint256__to_t_address_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "8416:9:17",
                "type": ""
              },
              {
                "name": "value1",
                "nodeType": "YulTypedName",
                "src": "8428:6:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "8436:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "8447:4:17",
                "type": ""
              }
            ],
            "src": "8326:332:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "8856:269:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "8866:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "8878:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "8889:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "8874:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8874:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8866:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8913:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "8924:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "8909:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8909:17:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "8932:4:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "8938:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "8928:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "8928:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "8902:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8902:47:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "8902:47:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "8958:160:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "9104:6:17"
                      },
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "9113:4:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "8966:137:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "8966:152:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "8958:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr__to_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "8828:9:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "8840:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "8851:4:17",
                "type": ""
              }
            ],
            "src": "8664:461:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9302:248:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "9312:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9324:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9335:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9320:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9320:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "9312:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9359:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9370:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9355:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9355:17:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "9378:4:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9384:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "9374:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9374:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9348:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9348:47:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9348:47:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "9404:139:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "9538:4:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "9412:124:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9412:131:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "9404:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "9282:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "9297:4:17",
                "type": ""
              }
            ],
            "src": "9131:419:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "9727:248:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "9737:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "9749:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "9760:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "9745:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9745:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "9737:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9784:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "9795:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "9780:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9780:17:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "9803:4:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "9809:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "9799:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "9799:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "9773:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9773:47:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "9773:47:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "9829:139:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "9963:4:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec_to_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "9837:124:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "9837:131:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "9829:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "9707:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "9722:4:17",
                "type": ""
              }
            ],
            "src": "9556:419:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10152:248:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "10162:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10174:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10185:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10170:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10170:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10162:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10209:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10220:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10205:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10205:17:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "10228:4:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10234:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "10224:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10224:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10198:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10198:47:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10198:47:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "10254:139:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "10388:4:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "10262:124:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10262:131:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10254:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "10132:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "10147:4:17",
                "type": ""
              }
            ],
            "src": "9981:419:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10577:248:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "10587:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10599:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10610:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10595:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10595:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10587:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10634:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "10645:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "10630:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10630:17:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "tail",
                            "nodeType": "YulIdentifier",
                            "src": "10653:4:17"
                          },
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "10659:9:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "10649:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "10649:20:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "10623:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10623:47:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10623:47:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "10679:139:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "tail",
                        "nodeType": "YulIdentifier",
                        "src": "10813:4:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c_to_t_string_memory_ptr_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "10687:124:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10687:131:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10679:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "abi_encode_tuple_t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c__to_t_string_memory_ptr__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "10557:9:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "10572:4:17",
                "type": ""
              }
            ],
            "src": "10406:419:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "10929:124:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "10939:26:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "headStart",
                        "nodeType": "YulIdentifier",
                        "src": "10951:9:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "10962:2:17",
                        "type": "",
                        "value": "32"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "10947:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10947:18:17"
                  },
                  "variableNames": [
                    {
                      "name": "tail",
                      "nodeType": "YulIdentifier",
                      "src": "10939:4:17"
                    }
                  ]
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "value0",
                        "nodeType": "YulIdentifier",
                        "src": "11019:6:17"
                      },
                      {
                        "arguments": [
                          {
                            "name": "headStart",
                            "nodeType": "YulIdentifier",
                            "src": "11032:9:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "11043:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "11028:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "11028:17:17"
                      }
                    ],
                    "functionName": {
                      "name": "abi_encode_t_uint256_to_t_uint256_fromStack",
                      "nodeType": "YulIdentifier",
                      "src": "10975:43:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "10975:71:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "10975:71:17"
                }
              ]
            },
            "name": "abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "headStart",
                "nodeType": "YulTypedName",
                "src": "10901:9:17",
                "type": ""
              },
              {
                "name": "value0",
                "nodeType": "YulTypedName",
                "src": "10913:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "tail",
                "nodeType": "YulTypedName",
                "src": "10924:4:17",
                "type": ""
              }
            ],
            "src": "10831:222:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11099:35:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "11109:19:17",
                  "value": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11125:2:17",
                        "type": "",
                        "value": "64"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "11119:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11119:9:17"
                  },
                  "variableNames": [
                    {
                      "name": "memPtr",
                      "nodeType": "YulIdentifier",
                      "src": "11109:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "allocate_unbounded",
            "nodeType": "YulFunctionDefinition",
            "returnVariables": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "11092:6:17",
                "type": ""
              }
            ],
            "src": "11059:75:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11234:60:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "11244:11:17",
                  "value": {
                    "name": "ptr",
                    "nodeType": "YulIdentifier",
                    "src": "11252:3:17"
                  },
                  "variableNames": [
                    {
                      "name": "data",
                      "nodeType": "YulIdentifier",
                      "src": "11244:4:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "11265:22:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "ptr",
                        "nodeType": "YulIdentifier",
                        "src": "11277:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11282:4:17",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "11273:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11273:14:17"
                  },
                  "variableNames": [
                    {
                      "name": "data",
                      "nodeType": "YulIdentifier",
                      "src": "11265:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "array_dataslot_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "ptr",
                "nodeType": "YulTypedName",
                "src": "11221:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "data",
                "nodeType": "YulTypedName",
                "src": "11229:4:17",
                "type": ""
              }
            ],
            "src": "11140:154:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11396:40:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "11407:22:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "11423:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "mload",
                      "nodeType": "YulIdentifier",
                      "src": "11417:5:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11417:12:17"
                  },
                  "variableNames": [
                    {
                      "name": "length",
                      "nodeType": "YulIdentifier",
                      "src": "11407:6:17"
                    }
                  ]
                }
              ]
            },
            "name": "array_length_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "11379:5:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "11389:6:17",
                "type": ""
              }
            ],
            "src": "11300:136:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11539:38:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "11549:22:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "ptr",
                        "nodeType": "YulIdentifier",
                        "src": "11561:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11566:4:17",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "11557:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11557:14:17"
                  },
                  "variableNames": [
                    {
                      "name": "next",
                      "nodeType": "YulIdentifier",
                      "src": "11549:4:17"
                    }
                  ]
                }
              ]
            },
            "name": "array_nextElement_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "ptr",
                "nodeType": "YulTypedName",
                "src": "11526:3:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "next",
                "nodeType": "YulTypedName",
                "src": "11534:4:17",
                "type": ""
              }
            ],
            "src": "11442:135:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11716:73:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "11733:3:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "11738:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11726:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11726:19:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11726:19:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "11754:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "11773:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11778:4:17",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "11769:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11769:14:17"
                  },
                  "variableNames": [
                    {
                      "name": "updated_pos",
                      "nodeType": "YulIdentifier",
                      "src": "11754:11:17"
                    }
                  ]
                }
              ]
            },
            "name": "array_storeLengthForEncoding_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "11688:3:17",
                "type": ""
              },
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "11693:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "updated_pos",
                "nodeType": "YulTypedName",
                "src": "11704:11:17",
                "type": ""
              }
            ],
            "src": "11583:206:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "11891:73:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "11908:3:17"
                      },
                      {
                        "name": "length",
                        "nodeType": "YulIdentifier",
                        "src": "11913:6:17"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "11901:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11901:19:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "11901:19:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "11929:29:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "pos",
                        "nodeType": "YulIdentifier",
                        "src": "11948:3:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "11953:4:17",
                        "type": "",
                        "value": "0x20"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "11944:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "11944:14:17"
                  },
                  "variableNames": [
                    {
                      "name": "updated_pos",
                      "nodeType": "YulIdentifier",
                      "src": "11929:11:17"
                    }
                  ]
                }
              ]
            },
            "name": "array_storeLengthForEncoding_t_string_memory_ptr_fromStack",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "pos",
                "nodeType": "YulTypedName",
                "src": "11863:3:17",
                "type": ""
              },
              {
                "name": "length",
                "nodeType": "YulTypedName",
                "src": "11868:6:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "updated_pos",
                "nodeType": "YulTypedName",
                "src": "11879:11:17",
                "type": ""
              }
            ],
            "src": "11795:169:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12014:261:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "12024:25:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "12047:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "cleanup_t_uint256",
                      "nodeType": "YulIdentifier",
                      "src": "12029:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12029:20:17"
                  },
                  "variableNames": [
                    {
                      "name": "x",
                      "nodeType": "YulIdentifier",
                      "src": "12024:1:17"
                    }
                  ]
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "12058:25:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "12081:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "cleanup_t_uint256",
                      "nodeType": "YulIdentifier",
                      "src": "12063:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12063:20:17"
                  },
                  "variableNames": [
                    {
                      "name": "y",
                      "nodeType": "YulIdentifier",
                      "src": "12058:1:17"
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "12221:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "12223:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "12223:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "12223:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "12142:1:17"
                      },
                      {
                        "arguments": [
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "12149:66:17",
                            "type": "",
                            "value": "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
                          },
                          {
                            "name": "y",
                            "nodeType": "YulIdentifier",
                            "src": "12217:1:17"
                          }
                        ],
                        "functionName": {
                          "name": "sub",
                          "nodeType": "YulIdentifier",
                          "src": "12145:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "12145:74:17"
                      }
                    ],
                    "functionName": {
                      "name": "gt",
                      "nodeType": "YulIdentifier",
                      "src": "12139:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12139:81:17"
                  },
                  "nodeType": "YulIf",
                  "src": "12136:107:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "12253:16:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "x",
                        "nodeType": "YulIdentifier",
                        "src": "12264:1:17"
                      },
                      {
                        "name": "y",
                        "nodeType": "YulIdentifier",
                        "src": "12267:1:17"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "12260:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12260:9:17"
                  },
                  "variableNames": [
                    {
                      "name": "sum",
                      "nodeType": "YulIdentifier",
                      "src": "12253:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "checked_add_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "x",
                "nodeType": "YulTypedName",
                "src": "12001:1:17",
                "type": ""
              },
              {
                "name": "y",
                "nodeType": "YulTypedName",
                "src": "12004:1:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "sum",
                "nodeType": "YulTypedName",
                "src": "12010:3:17",
                "type": ""
              }
            ],
            "src": "11970:305:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12326:51:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "12336:35:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "12365:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "cleanup_t_uint160",
                      "nodeType": "YulIdentifier",
                      "src": "12347:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12347:24:17"
                  },
                  "variableNames": [
                    {
                      "name": "cleaned",
                      "nodeType": "YulIdentifier",
                      "src": "12336:7:17"
                    }
                  ]
                }
              ]
            },
            "name": "cleanup_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "12308:5:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "cleaned",
                "nodeType": "YulTypedName",
                "src": "12318:7:17",
                "type": ""
              }
            ],
            "src": "12281:96:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12428:81:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "12438:65:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "12453:5:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12460:42:17",
                        "type": "",
                        "value": "0xffffffffffffffffffffffffffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "and",
                      "nodeType": "YulIdentifier",
                      "src": "12449:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12449:54:17"
                  },
                  "variableNames": [
                    {
                      "name": "cleaned",
                      "nodeType": "YulIdentifier",
                      "src": "12438:7:17"
                    }
                  ]
                }
              ]
            },
            "name": "cleanup_t_uint160",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "12410:5:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "cleaned",
                "nodeType": "YulTypedName",
                "src": "12420:7:17",
                "type": ""
              }
            ],
            "src": "12383:126:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12560:32:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "12570:16:17",
                  "value": {
                    "name": "value",
                    "nodeType": "YulIdentifier",
                    "src": "12581:5:17"
                  },
                  "variableNames": [
                    {
                      "name": "cleaned",
                      "nodeType": "YulIdentifier",
                      "src": "12570:7:17"
                    }
                  ]
                }
              ]
            },
            "name": "cleanup_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "12542:5:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "cleaned",
                "nodeType": "YulTypedName",
                "src": "12552:7:17",
                "type": ""
              }
            ],
            "src": "12515:77:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12641:190:17",
              "statements": [
                {
                  "nodeType": "YulAssignment",
                  "src": "12651:33:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "12678:5:17"
                      }
                    ],
                    "functionName": {
                      "name": "cleanup_t_uint256",
                      "nodeType": "YulIdentifier",
                      "src": "12660:17:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12660:24:17"
                  },
                  "variableNames": [
                    {
                      "name": "value",
                      "nodeType": "YulIdentifier",
                      "src": "12651:5:17"
                    }
                  ]
                },
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "12774:22:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [],
                          "functionName": {
                            "name": "panic_error_0x11",
                            "nodeType": "YulIdentifier",
                            "src": "12776:16:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "12776:18:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "12776:18:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "12699:5:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12706:66:17",
                        "type": "",
                        "value": "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
                      }
                    ],
                    "functionName": {
                      "name": "eq",
                      "nodeType": "YulIdentifier",
                      "src": "12696:2:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12696:77:17"
                  },
                  "nodeType": "YulIf",
                  "src": "12693:103:17"
                },
                {
                  "nodeType": "YulAssignment",
                  "src": "12805:20:17",
                  "value": {
                    "arguments": [
                      {
                        "name": "value",
                        "nodeType": "YulIdentifier",
                        "src": "12816:5:17"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12823:1:17",
                        "type": "",
                        "value": "1"
                      }
                    ],
                    "functionName": {
                      "name": "add",
                      "nodeType": "YulIdentifier",
                      "src": "12812:3:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12812:13:17"
                  },
                  "variableNames": [
                    {
                      "name": "ret",
                      "nodeType": "YulIdentifier",
                      "src": "12805:3:17"
                    }
                  ]
                }
              ]
            },
            "name": "increment_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "12627:5:17",
                "type": ""
              }
            ],
            "returnVariables": [
              {
                "name": "ret",
                "nodeType": "YulTypedName",
                "src": "12637:3:17",
                "type": ""
              }
            ],
            "src": "12598:233:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "12865:152:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12882:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12885:77:17",
                        "type": "",
                        "value": "35408467139433450592217433187231851964531694900788300625387963629091585785856"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "12875:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12875:88:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12875:88:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12979:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "12982:4:17",
                        "type": "",
                        "value": "0x11"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "12972:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12972:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12972:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13003:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13006:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "12996:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "12996:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "12996:15:17"
                }
              ]
            },
            "name": "panic_error_0x11",
            "nodeType": "YulFunctionDefinition",
            "src": "12837:180:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13051:152:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13068:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13071:77:17",
                        "type": "",
                        "value": "35408467139433450592217433187231851964531694900788300625387963629091585785856"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13061:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13061:88:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13061:88:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13165:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13168:4:17",
                        "type": "",
                        "value": "0x32"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13158:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13158:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13158:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13189:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13192:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "13182:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13182:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13182:15:17"
                }
              ]
            },
            "name": "panic_error_0x32",
            "nodeType": "YulFunctionDefinition",
            "src": "13023:180:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13237:152:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13254:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13257:77:17",
                        "type": "",
                        "value": "35408467139433450592217433187231851964531694900788300625387963629091585785856"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13247:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13247:88:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13247:88:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13351:1:17",
                        "type": "",
                        "value": "4"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13354:4:17",
                        "type": "",
                        "value": "0x41"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13344:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13344:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13344:15:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13375:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13378:4:17",
                        "type": "",
                        "value": "0x24"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "13368:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13368:15:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13368:15:17"
                }
              ]
            },
            "name": "panic_error_0x41",
            "nodeType": "YulFunctionDefinition",
            "src": "13209:180:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13484:28:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13501:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13504:1:17",
                        "type": "",
                        "value": "0"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "13494:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13494:12:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13494:12:17"
                }
              ]
            },
            "name": "revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db",
            "nodeType": "YulFunctionDefinition",
            "src": "13395:117:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13607:28:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13624:1:17",
                        "type": "",
                        "value": "0"
                      },
                      {
                        "kind": "number",
                        "nodeType": "YulLiteral",
                        "src": "13627:1:17",
                        "type": "",
                        "value": "0"
                      }
                    ],
                    "functionName": {
                      "name": "revert",
                      "nodeType": "YulIdentifier",
                      "src": "13617:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13617:12:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13617:12:17"
                }
              ]
            },
            "name": "revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b",
            "nodeType": "YulFunctionDefinition",
            "src": "13518:117:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13747:119:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "13769:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13777:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13765:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13765:14:17"
                      },
                      {
                        "hexValue": "4f776e61626c653a206e6577206f776e657220697320746865207a65726f2061",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "13781:34:17",
                        "type": "",
                        "value": "Ownable: new owner is the zero a"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13758:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13758:58:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13758:58:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "13837:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "13845:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13833:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13833:15:17"
                      },
                      {
                        "hexValue": "646472657373",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "13850:8:17",
                        "type": "",
                        "value": "ddress"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13826:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13826:33:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13826:33:17"
                }
              ]
            },
            "name": "store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "13739:6:17",
                "type": ""
              }
            ],
            "src": "13641:225:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "13978:115:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "14000:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14008:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "13996:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "13996:14:17"
                      },
                      {
                        "hexValue": "43616e6e6f742066617563657420746865736520746f6b656e7320746f207573",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14012:34:17",
                        "type": "",
                        "value": "Cannot faucet these tokens to us"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "13989:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "13989:58:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "13989:58:17"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "14068:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14076:2:17",
                            "type": "",
                            "value": "32"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14064:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14064:15:17"
                      },
                      {
                        "hexValue": "6572",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14081:4:17",
                        "type": "",
                        "value": "er"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14057:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14057:29:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14057:29:17"
                }
              ]
            },
            "name": "store_literal_in_memory_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "13970:6:17",
                "type": ""
              }
            ],
            "src": "13872:221:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14205:76:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "14227:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14235:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14223:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14223:14:17"
                      },
                      {
                        "hexValue": "4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14239:34:17",
                        "type": "",
                        "value": "Ownable: caller is not the owner"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14216:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14216:58:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14216:58:17"
                }
              ]
            },
            "name": "store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "14197:6:17",
                "type": ""
              }
            ],
            "src": "14099:182:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14393:74:17",
              "statements": [
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "memPtr",
                            "nodeType": "YulIdentifier",
                            "src": "14415:6:17"
                          },
                          {
                            "kind": "number",
                            "nodeType": "YulLiteral",
                            "src": "14423:1:17",
                            "type": "",
                            "value": "0"
                          }
                        ],
                        "functionName": {
                          "name": "add",
                          "nodeType": "YulIdentifier",
                          "src": "14411:3:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14411:14:17"
                      },
                      {
                        "hexValue": "596f752063616e6e6f7420676574206d6f726520746f6b656e73206e6f77",
                        "kind": "string",
                        "nodeType": "YulLiteral",
                        "src": "14427:32:17",
                        "type": "",
                        "value": "You cannot get more tokens now"
                      }
                    ],
                    "functionName": {
                      "name": "mstore",
                      "nodeType": "YulIdentifier",
                      "src": "14404:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14404:56:17"
                  },
                  "nodeType": "YulExpressionStatement",
                  "src": "14404:56:17"
                }
              ]
            },
            "name": "store_literal_in_memory_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "memPtr",
                "nodeType": "YulTypedName",
                "src": "14385:6:17",
                "type": ""
              }
            ],
            "src": "14287:180:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14516:79:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "14573:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "14582:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "14585:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "14575:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "14575:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "14575:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "14539:5:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "14564:5:17"
                              }
                            ],
                            "functionName": {
                              "name": "cleanup_t_address",
                              "nodeType": "YulIdentifier",
                              "src": "14546:17:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "14546:24:17"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "14536:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14536:35:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "14529:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14529:43:17"
                  },
                  "nodeType": "YulIf",
                  "src": "14526:63:17"
                }
              ]
            },
            "name": "validator_revert_t_address",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "14509:5:17",
                "type": ""
              }
            ],
            "src": "14473:122:17"
          },
          {
            "body": {
              "nodeType": "YulBlock",
              "src": "14644:79:17",
              "statements": [
                {
                  "body": {
                    "nodeType": "YulBlock",
                    "src": "14701:16:17",
                    "statements": [
                      {
                        "expression": {
                          "arguments": [
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "14710:1:17",
                              "type": "",
                              "value": "0"
                            },
                            {
                              "kind": "number",
                              "nodeType": "YulLiteral",
                              "src": "14713:1:17",
                              "type": "",
                              "value": "0"
                            }
                          ],
                          "functionName": {
                            "name": "revert",
                            "nodeType": "YulIdentifier",
                            "src": "14703:6:17"
                          },
                          "nodeType": "YulFunctionCall",
                          "src": "14703:12:17"
                        },
                        "nodeType": "YulExpressionStatement",
                        "src": "14703:12:17"
                      }
                    ]
                  },
                  "condition": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "name": "value",
                            "nodeType": "YulIdentifier",
                            "src": "14667:5:17"
                          },
                          {
                            "arguments": [
                              {
                                "name": "value",
                                "nodeType": "YulIdentifier",
                                "src": "14692:5:17"
                              }
                            ],
                            "functionName": {
                              "name": "cleanup_t_uint256",
                              "nodeType": "YulIdentifier",
                              "src": "14674:17:17"
                            },
                            "nodeType": "YulFunctionCall",
                            "src": "14674:24:17"
                          }
                        ],
                        "functionName": {
                          "name": "eq",
                          "nodeType": "YulIdentifier",
                          "src": "14664:2:17"
                        },
                        "nodeType": "YulFunctionCall",
                        "src": "14664:35:17"
                      }
                    ],
                    "functionName": {
                      "name": "iszero",
                      "nodeType": "YulIdentifier",
                      "src": "14657:6:17"
                    },
                    "nodeType": "YulFunctionCall",
                    "src": "14657:43:17"
                  },
                  "nodeType": "YulIf",
                  "src": "14654:63:17"
                }
              ]
            },
            "name": "validator_revert_t_uint256",
            "nodeType": "YulFunctionDefinition",
            "parameters": [
              {
                "name": "value",
                "nodeType": "YulTypedName",
                "src": "14637:5:17",
                "type": ""
              }
            ],
            "src": "14601:122:17"
          }
        ]
      },
      "contents": "{\n\n    function abi_decode_t_address(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_address(value)\n    }\n\n    function abi_decode_t_address_fromMemory(offset, end) -> value {\n        value := mload(offset)\n        validator_revert_t_address(value)\n    }\n\n    function abi_decode_t_uint256(offset, end) -> value {\n        value := calldataload(offset)\n        validator_revert_t_uint256(value)\n    }\n\n    function abi_decode_t_uint256_fromMemory(offset, end) -> value {\n        value := mload(offset)\n        validator_revert_t_uint256(value)\n    }\n\n    function abi_decode_tuple_t_address(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_address_fromMemory(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_address_fromMemory(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_addresst_address(headStart, dataEnd) -> value0, value1 {\n        if slt(sub(dataEnd, headStart), 64) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n\n            let offset := 32\n\n            value1 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_addresst_addresst_uint256t_uint256(headStart, dataEnd) -> value0, value1, value2, value3 {\n        if slt(sub(dataEnd, headStart), 128) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n\n            let offset := 32\n\n            value1 := abi_decode_t_address(add(headStart, offset), dataEnd)\n        }\n\n        {\n\n            let offset := 64\n\n            value2 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n        {\n\n            let offset := 96\n\n            value3 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_uint256(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_uint256(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_decode_tuple_t_uint256_fromMemory(headStart, dataEnd) -> value0 {\n        if slt(sub(dataEnd, headStart), 32) { revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() }\n\n        {\n\n            let offset := 0\n\n            value0 := abi_decode_t_uint256_fromMemory(add(headStart, offset), dataEnd)\n        }\n\n    }\n\n    function abi_encodeUpdatedPos_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr(value0, pos) -> updatedPos {\n        abi_encode_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr(value0, pos)\n        updatedPos := add(pos, 0xa0)\n    }\n\n    function abi_encode_t_address_to_t_address(value, pos) {\n        mstore(pos, cleanup_t_address(value))\n    }\n\n    function abi_encode_t_address_to_t_address_fromStack(value, pos) {\n        mstore(pos, cleanup_t_address(value))\n    }\n\n    // struct StakerFactory.Farm[] -> struct StakerFactory.Farm[]\n    function abi_encode_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack(value, pos)  -> end  {\n        let length := array_length_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr(value)\n        pos := array_storeLengthForEncoding_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack(pos, length)\n        let baseRef := array_dataslot_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr(value)\n        let srcPtr := baseRef\n        for { let i := 0 } lt(i, length) { i := add(i, 1) }\n        {\n            let elementValue0 := mload(srcPtr)\n            pos := abi_encodeUpdatedPos_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr(elementValue0, pos)\n            srcPtr := array_nextElement_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr(srcPtr)\n        }\n        end := pos\n    }\n\n    function abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack(pos) -> end {\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 38)\n        store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe(pos)\n        end := add(pos, 64)\n    }\n\n    function abi_encode_t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec_to_t_string_memory_ptr_fromStack(pos) -> end {\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 34)\n        store_literal_in_memory_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec(pos)\n        end := add(pos, 64)\n    }\n\n    function abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack(pos) -> end {\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 32)\n        store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe(pos)\n        end := add(pos, 32)\n    }\n\n    function abi_encode_t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c_to_t_string_memory_ptr_fromStack(pos) -> end {\n        pos := array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, 30)\n        store_literal_in_memory_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c(pos)\n        end := add(pos, 32)\n    }\n\n    // struct StakerFactory.Farm -> struct StakerFactory.Farm\n    function abi_encode_t_struct$_Farm_$2368_memory_ptr_to_t_struct$_Farm_$2368_memory_ptr(value, pos)  {\n        let tail := add(pos, 0xa0)\n\n        {\n            // farm\n\n            let memberValue0 := mload(add(value, 0x00))\n            abi_encode_t_address_to_t_address(memberValue0, add(pos, 0x00))\n        }\n\n        {\n            // stake\n\n            let memberValue0 := mload(add(value, 0x20))\n            abi_encode_t_address_to_t_address(memberValue0, add(pos, 0x20))\n        }\n\n        {\n            // reward\n\n            let memberValue0 := mload(add(value, 0x40))\n            abi_encode_t_address_to_t_address(memberValue0, add(pos, 0x40))\n        }\n\n        {\n            // startTime\n\n            let memberValue0 := mload(add(value, 0x60))\n            abi_encode_t_uint256_to_t_uint256(memberValue0, add(pos, 0x60))\n        }\n\n        {\n            // endTime\n\n            let memberValue0 := mload(add(value, 0x80))\n            abi_encode_t_uint256_to_t_uint256(memberValue0, add(pos, 0x80))\n        }\n\n    }\n\n    function abi_encode_t_uint256_to_t_uint256(value, pos) {\n        mstore(pos, cleanup_t_uint256(value))\n    }\n\n    function abi_encode_t_uint256_to_t_uint256_fromStack(value, pos) {\n        mstore(pos, cleanup_t_uint256(value))\n    }\n\n    function abi_encode_tuple_t_address__to_t_address__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\n\n    }\n\n    function abi_encode_tuple_t_address_t_address_t_uint256_t_uint256__to_t_address_t_address_t_uint256_t_uint256__fromStack_reversed(headStart , value3, value2, value1, value0) -> tail {\n        tail := add(headStart, 128)\n\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\n\n        abi_encode_t_address_to_t_address_fromStack(value1,  add(headStart, 32))\n\n        abi_encode_t_uint256_to_t_uint256_fromStack(value2,  add(headStart, 64))\n\n        abi_encode_t_uint256_to_t_uint256_fromStack(value3,  add(headStart, 96))\n\n    }\n\n    function abi_encode_tuple_t_address_t_uint256__to_t_address_t_uint256__fromStack_reversed(headStart , value1, value0) -> tail {\n        tail := add(headStart, 64)\n\n        abi_encode_t_address_to_t_address_fromStack(value0,  add(headStart, 0))\n\n        abi_encode_t_uint256_to_t_uint256_fromStack(value1,  add(headStart, 32))\n\n    }\n\n    function abi_encode_tuple_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr__to_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_to_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack(value0,  tail)\n\n    }\n\n    function abi_encode_tuple_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_stringliteral_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe_to_t_string_memory_ptr_fromStack( tail)\n\n    }\n\n    function abi_encode_tuple_t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec_to_t_string_memory_ptr_fromStack( tail)\n\n    }\n\n    function abi_encode_tuple_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_stringliteral_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe_to_t_string_memory_ptr_fromStack( tail)\n\n    }\n\n    function abi_encode_tuple_t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c__to_t_string_memory_ptr__fromStack_reversed(headStart ) -> tail {\n        tail := add(headStart, 32)\n\n        mstore(add(headStart, 0), sub(tail, headStart))\n        tail := abi_encode_t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c_to_t_string_memory_ptr_fromStack( tail)\n\n    }\n\n    function abi_encode_tuple_t_uint256__to_t_uint256__fromStack_reversed(headStart , value0) -> tail {\n        tail := add(headStart, 32)\n\n        abi_encode_t_uint256_to_t_uint256_fromStack(value0,  add(headStart, 0))\n\n    }\n\n    function allocate_unbounded() -> memPtr {\n        memPtr := mload(64)\n    }\n\n    function array_dataslot_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr(ptr) -> data {\n        data := ptr\n\n        data := add(ptr, 0x20)\n\n    }\n\n    function array_length_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr(value) -> length {\n\n        length := mload(value)\n\n    }\n\n    function array_nextElement_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr(ptr) -> next {\n        next := add(ptr, 0x20)\n    }\n\n    function array_storeLengthForEncoding_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_fromStack(pos, length) -> updated_pos {\n        mstore(pos, length)\n        updated_pos := add(pos, 0x20)\n    }\n\n    function array_storeLengthForEncoding_t_string_memory_ptr_fromStack(pos, length) -> updated_pos {\n        mstore(pos, length)\n        updated_pos := add(pos, 0x20)\n    }\n\n    function checked_add_t_uint256(x, y) -> sum {\n        x := cleanup_t_uint256(x)\n        y := cleanup_t_uint256(y)\n\n        // overflow, if x > (maxValue - y)\n        if gt(x, sub(0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff, y)) { panic_error_0x11() }\n\n        sum := add(x, y)\n    }\n\n    function cleanup_t_address(value) -> cleaned {\n        cleaned := cleanup_t_uint160(value)\n    }\n\n    function cleanup_t_uint160(value) -> cleaned {\n        cleaned := and(value, 0xffffffffffffffffffffffffffffffffffffffff)\n    }\n\n    function cleanup_t_uint256(value) -> cleaned {\n        cleaned := value\n    }\n\n    function increment_t_uint256(value) -> ret {\n        value := cleanup_t_uint256(value)\n        if eq(value, 0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff) { panic_error_0x11() }\n        ret := add(value, 1)\n    }\n\n    function panic_error_0x11() {\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\n        mstore(4, 0x11)\n        revert(0, 0x24)\n    }\n\n    function panic_error_0x32() {\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\n        mstore(4, 0x32)\n        revert(0, 0x24)\n    }\n\n    function panic_error_0x41() {\n        mstore(0, 35408467139433450592217433187231851964531694900788300625387963629091585785856)\n        mstore(4, 0x41)\n        revert(0, 0x24)\n    }\n\n    function revert_error_c1322bf8034eace5e0b5c7295db60986aa89aae5e0ea0873e4689e076861a5db() {\n        revert(0, 0)\n    }\n\n    function revert_error_dbdddcbe895c83990c08b3492a0e83918d802a52331272ac6fdb6a7c4aea3b1b() {\n        revert(0, 0)\n    }\n\n    function store_literal_in_memory_245f15ff17f551913a7a18385165551503906a406f905ac1c2437281a7cd0cfe(memPtr) {\n\n        mstore(add(memPtr, 0), \"Ownable: new owner is the zero a\")\n\n        mstore(add(memPtr, 32), \"ddress\")\n\n    }\n\n    function store_literal_in_memory_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec(memPtr) {\n\n        mstore(add(memPtr, 0), \"Cannot faucet these tokens to us\")\n\n        mstore(add(memPtr, 32), \"er\")\n\n    }\n\n    function store_literal_in_memory_9924ebdf1add33d25d4ef888e16131f0a5687b0580a36c21b5c301a6c462effe(memPtr) {\n\n        mstore(add(memPtr, 0), \"Ownable: caller is not the owner\")\n\n    }\n\n    function store_literal_in_memory_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c(memPtr) {\n\n        mstore(add(memPtr, 0), \"You cannot get more tokens now\")\n\n    }\n\n    function validator_revert_t_address(value) {\n        if iszero(eq(value, cleanup_t_address(value))) { revert(0, 0) }\n    }\n\n    function validator_revert_t_uint256(value) {\n        if iszero(eq(value, cleanup_t_uint256(value))) { revert(0, 0) }\n    }\n\n}\n",
      "id": 17,
      "language": "Yul",
      "name": "#utility.yul"
    }
  ],
  "sourceMap": "281:2282:15:-:0;;;563:6;537:32;;639:13;611:41;;281:2282;;;;;;;;;;867:23:2;877:12;:10;;;:12;;;:::i;:::-;867:9;;;:23;;;:::i;:::-;281:2282:15;;587:96:6;640:7;666:10;659:17;;587:96;:::o;2041:169:2:-;2096:16;2115:6;;;;;;;;;;;2096:25;;2140:8;2131:6;;:17;;;;;;;;;;;;;;;;;;2194:8;2163:40;;2184:8;2163:40;;;;;;;;;;;;2086:124;2041:169;:::o;281:2282:15:-;;;;;;;",
  "deployedSourceMap": "281:2282:15:-:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;444:22;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;947:551;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;1806:755;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;537:32;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1605:92:2;;;:::i;:::-;;611:41:15;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;402:38;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;973:85:2;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1502:300:15;;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;470:63;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;;;;;;:::i;:::-;;;;;;;;1846:189:2;;;;;;;;;;;;;:::i;:::-;;:::i;:::-;;444:22:15;;;;:::o;947:551::-;1196:12:2;:10;:12::i;:::-;1185:23;;:7;:5;:7::i;:::-;:23;;;1177:68;;;;;;;;;;;;:::i;:::-;;;;;;;;;1160:13:15::1;1187:7;1196;1205:9;1216:7;1176:48;;;;;:::i;:::-;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;1160:64;;1258:6;1230:5;:17;1236:10;;1230:17;;;;;;;;;;;;:35;;;;;;;;;;;;;;;;;;1344:9;1363:7;1344:27;;1377:2;:26;;;1412:6;1377:43;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;::::0;::::1;;;;;;;;;;;;::::0;::::1;;;;;;;;;1439:17;1454:1;1439:10;;:14;;:17;;;;:::i;:::-;1426:10;:30;;;;1485:6;1467:26;;;;;;;;;;;;1048:450;;947:551:::0;;;;:::o;1806:755::-;1933:13;1949:11;:23;1961:10;1949:23;;;;;;;;;;;;;;;:30;1973:5;1949:30;;;;;;;;;;;;;;;;1933:46;;2006:1;1994:8;:13;:59;;;;2038:15;2023:11;;2012:8;:22;;;;:::i;:::-;2011:42;1994:59;1985:103;;;;;;;;;;;;:::i;:::-;;;;;;;;;2127:15;2094:11;:23;2106:10;2094:23;;;;;;;;;;;;;;;:30;2118:5;2094:30;;;;;;;;;;;;;;;:48;;;;2148:13;2171:10;2148:34;;2222:4;2196:31;;:6;:12;;;:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;:31;;;2188:78;;;;;;;;;;;;:::i;:::-;;;;;;;;;2444:6;:11;;;2456:5;2463:13;;2444:33;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2535:5;2505:51;;2523:10;2505:51;;;2542:13;;2505:51;;;;;;:::i;:::-;;;;;;;;1872:689;;1806:755;;:::o;537:32::-;;;;:::o;1605:92:2:-;1196:12;:10;:12::i;:::-;1185:23;;:7;:5;:7::i;:::-;:23;;;1177:68;;;;;;;;;;;;:::i;:::-;;;;;;;;;1669:21:::1;1687:1;1669:9;:21::i;:::-;1605:92::o:0;611:41:15:-;;;;:::o;402:38::-;;;;;;;;;;;;;;;;;;;;;;:::o;973:85:2:-;1019:7;1045:6;;;;;;;;;;;1038:13;;973:85;:::o;1502:300:15:-;1542:13;1563:17;1594:10;;1583:22;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;;;;;;;;;;;;;1563:42;;1615:6;1611:171;1631:10;;1627:1;:14;1611:171;;;1656:8;1674:5;:8;1680:1;1674:8;;;;;;;;;;;;;;;;;;;;;1656:27;;1700:75;;;;;;;;1705:5;:8;1711:1;1705:8;;;;;;;;;;;;;;;;;;;;;1700:75;;;;;;1715:1;:12;;;:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1700:75;;;;;;1731:1;:13;;;:15;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1700:75;;;;;;1748:1;:11;;;:13;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1700:75;;;;1763:1;:9;;;:11;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;1700:75;;;1691:3;1695:1;1691:6;;;;;;;;:::i;:::-;;;;;;;:84;;;;1648:134;1643:3;;;;;:::i;:::-;;;;1611:171;;;;1794:3;1787:10;;;1502:300;:::o;470:63::-;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;1846:189:2:-;1196:12;:10;:12::i;:::-;1185:23;;:7;:5;:7::i;:::-;:23;;;1177:68;;;;;;;;;;;;:::i;:::-;;;;;;;;;1954:1:::1;1934:22;;:8;:22;;;;1926:73;;;;;;;;;;;;:::i;:::-;;;;;;;;;2009:19;2019:8;2009:9;:19::i;:::-;1846:189:::0;:::o;587:96:6:-;640:7;666:10;659:17;;587:96;:::o;2672::10:-;2730:7;2760:1;2756;:5;;;;:::i;:::-;2749:12;;2672:96;;;;:::o;2041:169:2:-;2096:16;2115:6;;;;;;;;;;;2096:25;;2140:8;2131:6;;:17;;;;;;;;;;;;;;;;;;2194:8;2163:40;;2184:8;2163:40;;;;;;;;;;;;2086:124;2041:169;:::o;-1:-1:-1:-;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;7:139:17:-;53:5;91:6;78:20;69:29;;107:33;134:5;107:33;:::i;:::-;7:139;;;;:::o;152:143::-;209:5;240:6;234:13;225:22;;256:33;283:5;256:33;:::i;:::-;152:143;;;;:::o;301:139::-;347:5;385:6;372:20;363:29;;401:33;428:5;401:33;:::i;:::-;301:139;;;;:::o;446:143::-;503:5;534:6;528:13;519:22;;550:33;577:5;550:33;:::i;:::-;446:143;;;;:::o;595:329::-;654:6;703:2;691:9;682:7;678:23;674:32;671:119;;;709:79;;:::i;:::-;671:119;829:1;854:53;899:7;890:6;879:9;875:22;854:53;:::i;:::-;844:63;;800:117;595:329;;;;:::o;930:351::-;1000:6;1049:2;1037:9;1028:7;1024:23;1020:32;1017:119;;;1055:79;;:::i;:::-;1017:119;1175:1;1200:64;1256:7;1247:6;1236:9;1232:22;1200:64;:::i;:::-;1190:74;;1146:128;930:351;;;;:::o;1287:474::-;1355:6;1363;1412:2;1400:9;1391:7;1387:23;1383:32;1380:119;;;1418:79;;:::i;:::-;1380:119;1538:1;1563:53;1608:7;1599:6;1588:9;1584:22;1563:53;:::i;:::-;1553:63;;1509:117;1665:2;1691:53;1736:7;1727:6;1716:9;1712:22;1691:53;:::i;:::-;1681:63;;1636:118;1287:474;;;;;:::o;1767:765::-;1853:6;1861;1869;1877;1926:3;1914:9;1905:7;1901:23;1897:33;1894:120;;;1933:79;;:::i;:::-;1894:120;2053:1;2078:53;2123:7;2114:6;2103:9;2099:22;2078:53;:::i;:::-;2068:63;;2024:117;2180:2;2206:53;2251:7;2242:6;2231:9;2227:22;2206:53;:::i;:::-;2196:63;;2151:118;2308:2;2334:53;2379:7;2370:6;2359:9;2355:22;2334:53;:::i;:::-;2324:63;;2279:118;2436:2;2462:53;2507:7;2498:6;2487:9;2483:22;2462:53;:::i;:::-;2452:63;;2407:118;1767:765;;;;;;;:::o;2538:329::-;2597:6;2646:2;2634:9;2625:7;2621:23;2617:32;2614:119;;;2652:79;;:::i;:::-;2614:119;2772:1;2797:53;2842:7;2833:6;2822:9;2818:22;2797:53;:::i;:::-;2787:63;;2743:117;2538:329;;;;:::o;2873:351::-;2943:6;2992:2;2980:9;2971:7;2967:23;2963:32;2960:119;;;2998:79;;:::i;:::-;2960:119;3118:1;3143:64;3199:7;3190:6;3179:9;3175:22;3143:64;:::i;:::-;3133:74;;3089:128;2873:351;;;;:::o;3230:267::-;3343:10;3364:90;3450:3;3442:6;3364:90;:::i;:::-;3486:4;3481:3;3477:14;3463:28;;3230:267;;;;:::o;3503:108::-;3580:24;3598:5;3580:24;:::i;:::-;3575:3;3568:37;3503:108;;:::o;3617:118::-;3704:24;3722:5;3704:24;:::i;:::-;3699:3;3692:37;3617:118;;:::o;3807:908::-;3970:3;3999:76;4069:5;3999:76;:::i;:::-;4091:108;4192:6;4187:3;4091:108;:::i;:::-;4084:115;;4223:78;4295:5;4223:78;:::i;:::-;4324:7;4355:1;4340:350;4365:6;4362:1;4359:13;4340:350;;;4441:6;4435:13;4468:107;4571:3;4556:13;4468:107;:::i;:::-;4461:114;;4598:82;4673:6;4598:82;:::i;:::-;4588:92;;4400:290;4387:1;4384;4380:9;4375:14;;4340:350;;;4344:14;4706:3;4699:10;;3975:740;;;3807:908;;;;:::o;4721:366::-;4863:3;4884:67;4948:2;4943:3;4884:67;:::i;:::-;4877:74;;4960:93;5049:3;4960:93;:::i;:::-;5078:2;5073:3;5069:12;5062:19;;4721:366;;;:::o;5093:::-;5235:3;5256:67;5320:2;5315:3;5256:67;:::i;:::-;5249:74;;5332:93;5421:3;5332:93;:::i;:::-;5450:2;5445:3;5441:12;5434:19;;5093:366;;;:::o;5465:::-;5607:3;5628:67;5692:2;5687:3;5628:67;:::i;:::-;5621:74;;5704:93;5793:3;5704:93;:::i;:::-;5822:2;5817:3;5813:12;5806:19;;5465:366;;;:::o;5837:::-;5979:3;6000:67;6064:2;6059:3;6000:67;:::i;:::-;5993:74;;6076:93;6165:3;6076:93;:::i;:::-;6194:2;6189:3;6185:12;6178:19;;5837:366;;;:::o;6271:1024::-;6402:4;6397:3;6393:14;6489:4;6482:5;6478:16;6472:23;6508:63;6565:4;6560:3;6556:14;6542:12;6508:63;:::i;:::-;6417:164;6664:4;6657:5;6653:16;6647:23;6683:63;6740:4;6735:3;6731:14;6717:12;6683:63;:::i;:::-;6591:165;6840:4;6833:5;6829:16;6823:23;6859:63;6916:4;6911:3;6907:14;6893:12;6859:63;:::i;:::-;6766:166;7019:4;7012:5;7008:16;7002:23;7038:63;7095:4;7090:3;7086:14;7072:12;7038:63;:::i;:::-;6942:169;7196:4;7189:5;7185:16;7179:23;7215:63;7272:4;7267:3;7263:14;7249:12;7215:63;:::i;:::-;7121:167;6371:924;6271:1024;;:::o;7301:108::-;7378:24;7396:5;7378:24;:::i;:::-;7373:3;7366:37;7301:108;;:::o;7415:118::-;7502:24;7520:5;7502:24;:::i;:::-;7497:3;7490:37;7415:118;;:::o;7539:222::-;7632:4;7670:2;7659:9;7655:18;7647:26;;7683:71;7751:1;7740:9;7736:17;7727:6;7683:71;:::i;:::-;7539:222;;;;:::o;7767:553::-;7944:4;7982:3;7971:9;7967:19;7959:27;;7996:71;8064:1;8053:9;8049:17;8040:6;7996:71;:::i;:::-;8077:72;8145:2;8134:9;8130:18;8121:6;8077:72;:::i;:::-;8159;8227:2;8216:9;8212:18;8203:6;8159:72;:::i;:::-;8241;8309:2;8298:9;8294:18;8285:6;8241:72;:::i;:::-;7767:553;;;;;;;:::o;8326:332::-;8447:4;8485:2;8474:9;8470:18;8462:26;;8498:71;8566:1;8555:9;8551:17;8542:6;8498:71;:::i;:::-;8579:72;8647:2;8636:9;8632:18;8623:6;8579:72;:::i;:::-;8326:332;;;;;:::o;8664:461::-;8851:4;8889:2;8878:9;8874:18;8866:26;;8938:9;8932:4;8928:20;8924:1;8913:9;8909:17;8902:47;8966:152;9113:4;9104:6;8966:152;:::i;:::-;8958:160;;8664:461;;;;:::o;9131:419::-;9297:4;9335:2;9324:9;9320:18;9312:26;;9384:9;9378:4;9374:20;9370:1;9359:9;9355:17;9348:47;9412:131;9538:4;9412:131;:::i;:::-;9404:139;;9131:419;;;:::o;9556:::-;9722:4;9760:2;9749:9;9745:18;9737:26;;9809:9;9803:4;9799:20;9795:1;9784:9;9780:17;9773:47;9837:131;9963:4;9837:131;:::i;:::-;9829:139;;9556:419;;;:::o;9981:::-;10147:4;10185:2;10174:9;10170:18;10162:26;;10234:9;10228:4;10224:20;10220:1;10209:9;10205:17;10198:47;10262:131;10388:4;10262:131;:::i;:::-;10254:139;;9981:419;;;:::o;10406:::-;10572:4;10610:2;10599:9;10595:18;10587:26;;10659:9;10653:4;10649:20;10645:1;10634:9;10630:17;10623:47;10687:131;10813:4;10687:131;:::i;:::-;10679:139;;10406:419;;;:::o;10831:222::-;10924:4;10962:2;10951:9;10947:18;10939:26;;10975:71;11043:1;11032:9;11028:17;11019:6;10975:71;:::i;:::-;10831:222;;;;:::o;11140:154::-;11229:4;11252:3;11244:11;;11282:4;11277:3;11273:14;11265:22;;11140:154;;;:::o;11300:136::-;11389:6;11423:5;11417:12;11407:22;;11300:136;;;:::o;11442:135::-;11534:4;11566;11561:3;11557:14;11549:22;;11442:135;;;:::o;11583:206::-;11704:11;11738:6;11733:3;11726:19;11778:4;11773:3;11769:14;11754:29;;11583:206;;;;:::o;11795:169::-;11879:11;11913:6;11908:3;11901:19;11953:4;11948:3;11944:14;11929:29;;11795:169;;;;:::o;11970:305::-;12010:3;12029:20;12047:1;12029:20;:::i;:::-;12024:25;;12063:20;12081:1;12063:20;:::i;:::-;12058:25;;12217:1;12149:66;12145:74;12142:1;12139:81;12136:107;;;12223:18;;:::i;:::-;12136:107;12267:1;12264;12260:9;12253:16;;11970:305;;;;:::o;12281:96::-;12318:7;12347:24;12365:5;12347:24;:::i;:::-;12336:35;;12281:96;;;:::o;12383:126::-;12420:7;12460:42;12453:5;12449:54;12438:65;;12383:126;;;:::o;12515:77::-;12552:7;12581:5;12570:16;;12515:77;;;:::o;12598:233::-;12637:3;12660:24;12678:5;12660:24;:::i;:::-;12651:33;;12706:66;12699:5;12696:77;12693:103;;;12776:18;;:::i;:::-;12693:103;12823:1;12816:5;12812:13;12805:20;;12598:233;;;:::o;12837:180::-;12885:77;12882:1;12875:88;12982:4;12979:1;12972:15;13006:4;13003:1;12996:15;13023:180;13071:77;13068:1;13061:88;13168:4;13165:1;13158:15;13192:4;13189:1;13182:15;13209:180;13257:77;13254:1;13247:88;13354:4;13351:1;13344:15;13378:4;13375:1;13368:15;13518:117;13627:1;13624;13617:12;13641:225;13781:34;13777:1;13769:6;13765:14;13758:58;13850:8;13845:2;13837:6;13833:15;13826:33;13641:225;:::o;13872:221::-;14012:34;14008:1;14000:6;13996:14;13989:58;14081:4;14076:2;14068:6;14064:15;14057:29;13872:221;:::o;14099:182::-;14239:34;14235:1;14227:6;14223:14;14216:58;14099:182;:::o;14287:180::-;14427:32;14423:1;14415:6;14411:14;14404:56;14287:180;:::o;14473:122::-;14546:24;14564:5;14546:24;:::i;:::-;14539:5;14536:35;14526:63;;14585:1;14582;14575:12;14526:63;14473:122;:::o;14601:::-;14674:24;14692:5;14674:24;:::i;:::-;14667:5;14664:35;14654:63;;14713:1;14710;14703:12;14654:63;14601:122;:::o",
  "source": "// SPDX-License-Identifier: MIT\npragma solidity >=0.4.22 <0.9.0;\n\nimport \"@openzeppelin/contracts/access/Ownable.sol\";\nimport \"@openzeppelin/contracts/utils/math/SafeMath.sol\";\nimport \"@openzeppelin/contracts/token/ERC20/IERC20.sol\";\nimport \"./Staker.sol\";\nimport \"./IToken.sol\";\n\ncontract StakerFactory is Ownable {\n  using SafeMath for uint;\n\n  //a farm is when you can add a token and get rewards\n  mapping (uint => address) public farms;\n  uint public totalFarms;\n  mapping(address => mapping(address => uint)) public faucetTimes;\n  uint public FAUCET_TIME = 1 days; //you can only grab x amount in a day\n  uint public FAUCET_AMOUNT = 1000 * 10**18; //this is how many tokens they get\n\n  event FacetTokensToUser(address indexed _token, address indexed _user, uint _amount);\n  event FarmAdded(address indexed _stakeAddress);\n\n  struct Farm {\n    address farm;\n    address stake;\n    address reward;\n    uint startTime;\n    uint endTime;\n  }\n\n  function createFarm(address _tokenA, address _tokenB, uint startTime, uint endTime) public onlyOwner {\n    //TOKEN B MUST BE OWNED BY THE CONTRACT! OR HAS PERMISSIONS TO APPROVE OTHER CONTRACTS TO MINT TOKENS\n    Staker staker = new Staker(_tokenA, _tokenB, startTime, endTime);\n    farms[totalFarms] = address(staker);\n    //add permissions for the reward token to mint tokens for the reward\n    IToken it = IToken(_tokenB);\n    it.addContractToMinterRole(address(staker));\n    totalFarms = totalFarms.add(1);\n    emit FarmAdded(address(staker));\n  }\n\n  function getFarms() view public returns(Farm[] memory) {\n    Farm[] memory ret = new Farm[](totalFarms);\n    for(uint i = 0; i < totalFarms; i++) {\n      Staker s = Staker(farms[i]);\n      ret[i] = Farm(farms[i], s.stakeToken(), s.rewardToken(), s.startTime(), s.endTime());\n    }\n    return ret;\n  }\n\n  function faucetTokens(address _tokenAddr, address _user) external {\n    //first check how much time past since last called\n    uint lastTime = faucetTimes[_tokenAddr][_user];\n    require (lastTime == 0 || (lastTime + FAUCET_TIME) < block.timestamp, \"You cannot get more tokens now\");\n    faucetTimes[_tokenAddr][_user] = block.timestamp;\n    IToken _token = IToken(_tokenAddr);\n    require(_token.owner() == address(this), \"Cannot faucet these tokens to user\");\n    // uint bal = _token.balanceOf(address(this));\n    // require(bal >= FAUCET_AMOUNT, \"Does not have enough tokens to provide you with.\");\n    //now send them the tokens\n    _token.mint(_user, FAUCET_AMOUNT);\n    //send event\n    emit FacetTokensToUser(_tokenAddr, _user, FAUCET_AMOUNT);\n  }\n}\n",
  "sourcePath": "C:\\Users\\surge\\Desktop\\dapp-projects\\staker-demo\\contracts\\StakerFactory.sol",
  "ast": {
    "absolutePath": "project:/contracts/StakerFactory.sol",
    "exportedSymbols": {
      "Context": [
        1154
      ],
      "IERC20": [
        1107
      ],
      "IToken": [
        1822
      ],
      "Ownable": [
        483
      ],
      "SafeMath": [
        1705
      ],
      "Staker": [
        2311
      ],
      "StakerFactory": [
        2571
      ]
    },
    "id": 2572,
    "license": "MIT",
    "nodeType": "SourceUnit",
    "nodes": [
      {
        "id": 2313,
        "literals": [
          "solidity",
          ">=",
          "0.4",
          ".22",
          "<",
          "0.9",
          ".0"
        ],
        "nodeType": "PragmaDirective",
        "src": "32:32:15"
      },
      {
        "absolutePath": "@openzeppelin/contracts/access/Ownable.sol",
        "file": "@openzeppelin/contracts/access/Ownable.sol",
        "id": 2314,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 484,
        "src": "66:52:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/math/SafeMath.sol",
        "file": "@openzeppelin/contracts/utils/math/SafeMath.sol",
        "id": 2315,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 1706,
        "src": "119:57:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/token/ERC20/IERC20.sol",
        "file": "@openzeppelin/contracts/token/ERC20/IERC20.sol",
        "id": 2316,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 1108,
        "src": "177:56:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "project:/contracts/Staker.sol",
        "file": "./Staker.sol",
        "id": 2317,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 2312,
        "src": "234:22:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "project:/contracts/IToken.sol",
        "file": "./IToken.sol",
        "id": 2318,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 1823,
        "src": "257:22:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 2319,
              "name": "Ownable",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 483,
              "src": "307:7:15"
            },
            "id": 2320,
            "nodeType": "InheritanceSpecifier",
            "src": "307:7:15"
          }
        ],
        "contractDependencies": [
          2311
        ],
        "contractKind": "contract",
        "fullyImplemented": true,
        "id": 2571,
        "linearizedBaseContracts": [
          2571,
          483,
          1154
        ],
        "name": "StakerFactory",
        "nameLocation": "290:13:15",
        "nodeType": "ContractDefinition",
        "nodes": [
          {
            "id": 2323,
            "libraryName": {
              "id": 2321,
              "name": "SafeMath",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1705,
              "src": "325:8:15"
            },
            "nodeType": "UsingForDirective",
            "src": "319:24:15",
            "typeName": {
              "id": 2322,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "338:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            }
          },
          {
            "constant": false,
            "functionSelector": "7da470ea",
            "id": 2327,
            "mutability": "mutable",
            "name": "farms",
            "nameLocation": "435:5:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "402:38:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
              "typeString": "mapping(uint256 => address)"
            },
            "typeName": {
              "id": 2326,
              "keyType": {
                "id": 2324,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "411:4:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "402:25:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                "typeString": "mapping(uint256 => address)"
              },
              "valueType": {
                "id": 2325,
                "name": "address",
                "nodeType": "ElementaryTypeName",
                "src": "419:7:15",
                "stateMutability": "nonpayable",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "4c995a7f",
            "id": 2329,
            "mutability": "mutable",
            "name": "totalFarms",
            "nameLocation": "456:10:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "444:22:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 2328,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "444:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "c8da3865",
            "id": 2335,
            "mutability": "mutable",
            "name": "faucetTimes",
            "nameLocation": "522:11:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "470:63:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
              "typeString": "mapping(address => mapping(address => uint256))"
            },
            "typeName": {
              "id": 2334,
              "keyType": {
                "id": 2330,
                "name": "address",
                "nodeType": "ElementaryTypeName",
                "src": "478:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Mapping",
              "src": "470:44:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                "typeString": "mapping(address => mapping(address => uint256))"
              },
              "valueType": {
                "id": 2333,
                "keyType": {
                  "id": 2331,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "497:7:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "nodeType": "Mapping",
                "src": "489:24:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                  "typeString": "mapping(address => uint256)"
                },
                "valueType": {
                  "id": 2332,
                  "name": "uint",
                  "nodeType": "ElementaryTypeName",
                  "src": "508:4:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  }
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "6bcfa4f9",
            "id": 2338,
            "mutability": "mutable",
            "name": "FAUCET_TIME",
            "nameLocation": "549:11:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "537:32:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 2336,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "537:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "31",
              "id": 2337,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "563:6:15",
              "subdenomination": "days",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_86400_by_1",
                "typeString": "int_const 86400"
              },
              "value": "1"
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "76697640",
            "id": 2345,
            "mutability": "mutable",
            "name": "FAUCET_AMOUNT",
            "nameLocation": "623:13:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "611:41:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 2339,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "611:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "commonType": {
                "typeIdentifier": "t_rational_1000000000000000000000_by_1",
                "typeString": "int_const 1000000000000000000000"
              },
              "id": 2344,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "lValueRequested": false,
              "leftExpression": {
                "hexValue": "31303030",
                "id": 2340,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "kind": "number",
                "lValueRequested": false,
                "nodeType": "Literal",
                "src": "639:4:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_1000_by_1",
                  "typeString": "int_const 1000"
                },
                "value": "1000"
              },
              "nodeType": "BinaryOperation",
              "operator": "*",
              "rightExpression": {
                "commonType": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                },
                "id": 2343,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "lValueRequested": false,
                "leftExpression": {
                  "hexValue": "3130",
                  "id": 2341,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "646:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_10_by_1",
                    "typeString": "int_const 10"
                  },
                  "value": "10"
                },
                "nodeType": "BinaryOperation",
                "operator": "**",
                "rightExpression": {
                  "hexValue": "3138",
                  "id": 2342,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "650:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_18_by_1",
                    "typeString": "int_const 18"
                  },
                  "value": "18"
                },
                "src": "646:6:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                }
              },
              "src": "639:13:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_1000000000000000000000_by_1",
                "typeString": "int_const 1000000000000000000000"
              }
            },
            "visibility": "public"
          },
          {
            "anonymous": false,
            "id": 2353,
            "name": "FacetTokensToUser",
            "nameLocation": "698:17:15",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 2352,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2347,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "732:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2353,
                  "src": "716:22:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2346,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "716:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2349,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "_user",
                  "nameLocation": "756:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2353,
                  "src": "740:21:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2348,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "740:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2351,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "768:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2353,
                  "src": "763:12:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2350,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "763:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "715:61:15"
            },
            "src": "692:85:15"
          },
          {
            "anonymous": false,
            "id": 2357,
            "name": "FarmAdded",
            "nameLocation": "786:9:15",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 2356,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2355,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "_stakeAddress",
                  "nameLocation": "812:13:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2357,
                  "src": "796:29:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2354,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "796:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "795:31:15"
            },
            "src": "780:47:15"
          },
          {
            "canonicalName": "StakerFactory.Farm",
            "id": 2368,
            "members": [
              {
                "constant": false,
                "id": 2359,
                "mutability": "mutable",
                "name": "farm",
                "nameLocation": "857:4:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "849:12:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                },
                "typeName": {
                  "id": 2358,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "849:7:15",
                  "stateMutability": "nonpayable",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2361,
                "mutability": "mutable",
                "name": "stake",
                "nameLocation": "875:5:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "867:13:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                },
                "typeName": {
                  "id": 2360,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "867:7:15",
                  "stateMutability": "nonpayable",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2363,
                "mutability": "mutable",
                "name": "reward",
                "nameLocation": "894:6:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "886:14:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                },
                "typeName": {
                  "id": 2362,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "886:7:15",
                  "stateMutability": "nonpayable",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2365,
                "mutability": "mutable",
                "name": "startTime",
                "nameLocation": "911:9:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "906:14:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                },
                "typeName": {
                  "id": 2364,
                  "name": "uint",
                  "nodeType": "ElementaryTypeName",
                  "src": "906:4:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2367,
                "mutability": "mutable",
                "name": "endTime",
                "nameLocation": "931:7:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "926:12:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                },
                "typeName": {
                  "id": 2366,
                  "name": "uint",
                  "nodeType": "ElementaryTypeName",
                  "src": "926:4:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  }
                },
                "visibility": "internal"
              }
            ],
            "name": "Farm",
            "nameLocation": "838:4:15",
            "nodeType": "StructDefinition",
            "scope": 2571,
            "src": "831:112:15",
            "visibility": "public"
          },
          {
            "body": {
              "id": 2432,
              "nodeType": "Block",
              "src": "1048:450:15",
              "statements": [
                {
                  "assignments": [
                    2383
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2383,
                      "mutability": "mutable",
                      "name": "staker",
                      "nameLocation": "1167:6:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2432,
                      "src": "1160:13:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_contract$_Staker_$2311",
                        "typeString": "contract Staker"
                      },
                      "typeName": {
                        "id": 2382,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2381,
                          "name": "Staker",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 2311,
                          "src": "1160:6:15"
                        },
                        "referencedDeclaration": 2311,
                        "src": "1160:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Staker_$2311",
                          "typeString": "contract Staker"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2392,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2387,
                        "name": "_tokenA",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2370,
                        "src": "1187:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2388,
                        "name": "_tokenB",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2372,
                        "src": "1196:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2389,
                        "name": "startTime",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2374,
                        "src": "1205:9:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 2390,
                        "name": "endTime",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2376,
                        "src": "1216:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2386,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "NewExpression",
                      "src": "1176:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_creation_nonpayable$_t_address_$_t_address_$_t_uint256_$_t_uint256_$returns$_t_contract$_Staker_$2311_$",
                        "typeString": "function (address,address,uint256,uint256) returns (contract Staker)"
                      },
                      "typeName": {
                        "id": 2385,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2384,
                          "name": "Staker",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 2311,
                          "src": "1180:6:15"
                        },
                        "referencedDeclaration": 2311,
                        "src": "1180:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Staker_$2311",
                          "typeString": "contract Staker"
                        }
                      }
                    },
                    "id": 2391,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1176:48:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Staker_$2311",
                      "typeString": "contract Staker"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1160:64:15"
                },
                {
                  "expression": {
                    "id": 2400,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 2393,
                        "name": "farms",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2327,
                        "src": "1230:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                          "typeString": "mapping(uint256 => address)"
                        }
                      },
                      "id": 2395,
                      "indexExpression": {
                        "id": 2394,
                        "name": "totalFarms",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2329,
                        "src": "1236:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "1230:17:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "arguments": [
                        {
                          "id": 2398,
                          "name": "staker",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2383,
                          "src": "1258:6:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_contract$_Staker_$2311",
                            "typeString": "contract Staker"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_contract$_Staker_$2311",
                            "typeString": "contract Staker"
                          }
                        ],
                        "id": 2397,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "nodeType": "ElementaryTypeNameExpression",
                        "src": "1250:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_address_$",
                          "typeString": "type(address)"
                        },
                        "typeName": {
                          "id": 2396,
                          "name": "address",
                          "nodeType": "ElementaryTypeName",
                          "src": "1250:7:15",
                          "typeDescriptions": {}
                        }
                      },
                      "id": 2399,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "typeConversion",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1250:15:15",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "1230:35:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 2401,
                  "nodeType": "ExpressionStatement",
                  "src": "1230:35:15"
                },
                {
                  "assignments": [
                    2404
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2404,
                      "mutability": "mutable",
                      "name": "it",
                      "nameLocation": "1351:2:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2432,
                      "src": "1344:9:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_contract$_IToken_$1822",
                        "typeString": "contract IToken"
                      },
                      "typeName": {
                        "id": 2403,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2402,
                          "name": "IToken",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 1822,
                          "src": "1344:6:15"
                        },
                        "referencedDeclaration": 1822,
                        "src": "1344:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2408,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2406,
                        "name": "_tokenB",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2372,
                        "src": "1363:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2405,
                      "name": "IToken",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1822,
                      "src": "1356:6:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_contract$_IToken_$1822_$",
                        "typeString": "type(contract IToken)"
                      }
                    },
                    "id": 2407,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1356:15:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IToken_$1822",
                      "typeString": "contract IToken"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1344:27:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2414,
                            "name": "staker",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2383,
                            "src": "1412:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          ],
                          "id": 2413,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "1404:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 2412,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "1404:7:15",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 2415,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "1404:15:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "expression": {
                        "id": 2409,
                        "name": "it",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2404,
                        "src": "1377:2:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "id": 2411,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "addContractToMinterRole",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1816,
                      "src": "1377:26:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$returns$__$",
                        "typeString": "function (address) external"
                      }
                    },
                    "id": 2416,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1377:43:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2417,
                  "nodeType": "ExpressionStatement",
                  "src": "1377:43:15"
                },
                {
                  "expression": {
                    "id": 2423,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2418,
                      "name": "totalFarms",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2329,
                      "src": "1426:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "arguments": [
                        {
                          "hexValue": "31",
                          "id": 2421,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "1454:1:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_1_by_1",
                            "typeString": "int_const 1"
                          },
                          "value": "1"
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_rational_1_by_1",
                            "typeString": "int_const 1"
                          }
                        ],
                        "expression": {
                          "id": 2419,
                          "name": "totalFarms",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2329,
                          "src": "1439:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 2420,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "add",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 1569,
                        "src": "1439:14:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                          "typeString": "function (uint256,uint256) pure returns (uint256)"
                        }
                      },
                      "id": 2422,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1439:17:15",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1426:30:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2424,
                  "nodeType": "ExpressionStatement",
                  "src": "1426:30:15"
                },
                {
                  "eventCall": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2428,
                            "name": "staker",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2383,
                            "src": "1485:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          ],
                          "id": 2427,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "1477:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 2426,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "1477:7:15",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 2429,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "1477:15:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2425,
                      "name": "FarmAdded",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2357,
                      "src": "1467:9:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_event_nonpayable$_t_address_$returns$__$",
                        "typeString": "function (address)"
                      }
                    },
                    "id": 2430,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1467:26:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2431,
                  "nodeType": "EmitStatement",
                  "src": "1462:31:15"
                }
              ]
            },
            "functionSelector": "4febcb34",
            "id": 2433,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2379,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2378,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 426,
                  "src": "1038:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "1038:9:15"
              }
            ],
            "name": "createFarm",
            "nameLocation": "956:10:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2377,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2370,
                  "mutability": "mutable",
                  "name": "_tokenA",
                  "nameLocation": "975:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "967:15:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2369,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "967:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2372,
                  "mutability": "mutable",
                  "name": "_tokenB",
                  "nameLocation": "992:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "984:15:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2371,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "984:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2374,
                  "mutability": "mutable",
                  "name": "startTime",
                  "nameLocation": "1006:9:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "1001:14:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2373,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1001:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2376,
                  "mutability": "mutable",
                  "name": "endTime",
                  "nameLocation": "1022:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "1017:12:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2375,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1017:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "966:64:15"
            },
            "returnParameters": {
              "id": 2380,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1048:0:15"
            },
            "scope": 2571,
            "src": "947:551:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2497,
              "nodeType": "Block",
              "src": "1557:245:15",
              "statements": [
                {
                  "assignments": [
                    2444
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2444,
                      "mutability": "mutable",
                      "name": "ret",
                      "nameLocation": "1577:3:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2497,
                      "src": "1563:17:15",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                        "typeString": "struct StakerFactory.Farm[]"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 2442,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 2441,
                            "name": "Farm",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2368,
                            "src": "1563:4:15"
                          },
                          "referencedDeclaration": 2368,
                          "src": "1563:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Farm_$2368_storage_ptr",
                            "typeString": "struct StakerFactory.Farm"
                          }
                        },
                        "id": 2443,
                        "nodeType": "ArrayTypeName",
                        "src": "1563:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Farm_$2368_storage_$dyn_storage_ptr",
                          "typeString": "struct StakerFactory.Farm[]"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2451,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2449,
                        "name": "totalFarms",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2329,
                        "src": "1594:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2448,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "NewExpression",
                      "src": "1583:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_$",
                        "typeString": "function (uint256) pure returns (struct StakerFactory.Farm memory[] memory)"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 2446,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 2445,
                            "name": "Farm",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2368,
                            "src": "1587:4:15"
                          },
                          "referencedDeclaration": 2368,
                          "src": "1587:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Farm_$2368_storage_ptr",
                            "typeString": "struct StakerFactory.Farm"
                          }
                        },
                        "id": 2447,
                        "nodeType": "ArrayTypeName",
                        "src": "1587:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Farm_$2368_storage_$dyn_storage_ptr",
                          "typeString": "struct StakerFactory.Farm[]"
                        }
                      }
                    },
                    "id": 2450,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1583:22:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct StakerFactory.Farm memory[] memory"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1563:42:15"
                },
                {
                  "body": {
                    "id": 2493,
                    "nodeType": "Block",
                    "src": "1648:134:15",
                    "statements": [
                      {
                        "assignments": [
                          2464
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 2464,
                            "mutability": "mutable",
                            "name": "s",
                            "nameLocation": "1663:1:15",
                            "nodeType": "VariableDeclaration",
                            "scope": 2493,
                            "src": "1656:8:15",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            },
                            "typeName": {
                              "id": 2463,
                              "nodeType": "UserDefinedTypeName",
                              "pathNode": {
                                "id": 2462,
                                "name": "Staker",
                                "nodeType": "IdentifierPath",
                                "referencedDeclaration": 2311,
                                "src": "1656:6:15"
                              },
                              "referencedDeclaration": 2311,
                              "src": "1656:6:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_Staker_$2311",
                                "typeString": "contract Staker"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 2470,
                        "initialValue": {
                          "arguments": [
                            {
                              "baseExpression": {
                                "id": 2466,
                                "name": "farms",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 2327,
                                "src": "1674:5:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                                  "typeString": "mapping(uint256 => address)"
                                }
                              },
                              "id": 2468,
                              "indexExpression": {
                                "id": 2467,
                                "name": "i",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 2453,
                                "src": "1680:1:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "IndexAccess",
                              "src": "1674:8:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            ],
                            "id": 2465,
                            "name": "Staker",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2311,
                            "src": "1667:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_contract$_Staker_$2311_$",
                              "typeString": "type(contract Staker)"
                            }
                          },
                          "id": 2469,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "typeConversion",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1667:16:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_contract$_Staker_$2311",
                            "typeString": "contract Staker"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "1656:27:15"
                      },
                      {
                        "expression": {
                          "id": 2491,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "baseExpression": {
                              "id": 2471,
                              "name": "ret",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2444,
                              "src": "1691:3:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                                "typeString": "struct StakerFactory.Farm memory[] memory"
                              }
                            },
                            "id": 2473,
                            "indexExpression": {
                              "id": 2472,
                              "name": "i",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2453,
                              "src": "1695:1:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "nodeType": "IndexAccess",
                            "src": "1691:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Farm_$2368_memory_ptr",
                              "typeString": "struct StakerFactory.Farm memory"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "arguments": [
                              {
                                "baseExpression": {
                                  "id": 2475,
                                  "name": "farms",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2327,
                                  "src": "1705:5:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                                    "typeString": "mapping(uint256 => address)"
                                  }
                                },
                                "id": 2477,
                                "indexExpression": {
                                  "id": 2476,
                                  "name": "i",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2453,
                                  "src": "1711:1:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "isConstant": false,
                                "isLValue": true,
                                "isPure": false,
                                "lValueRequested": false,
                                "nodeType": "IndexAccess",
                                "src": "1705:8:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2478,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1715:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2479,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "stakeToken",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1868,
                                  "src": "1715:12:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_address_$",
                                    "typeString": "function () view external returns (address)"
                                  }
                                },
                                "id": 2480,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1715:14:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2481,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1731:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2482,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "rewardToken",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1870,
                                  "src": "1731:13:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_address_$",
                                    "typeString": "function () view external returns (address)"
                                  }
                                },
                                "id": 2483,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1731:15:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2484,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1748:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2485,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "startTime",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1872,
                                  "src": "1748:11:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
                                    "typeString": "function () view external returns (uint256)"
                                  }
                                },
                                "id": 2486,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1748:13:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2487,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1763:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2488,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "endTime",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1874,
                                  "src": "1763:9:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
                                    "typeString": "function () view external returns (uint256)"
                                  }
                                },
                                "id": 2489,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1763:11:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              }
                            ],
                            "expression": {
                              "argumentTypes": [
                                {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                },
                                {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                },
                                {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                },
                                {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                },
                                {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              ],
                              "id": 2474,
                              "name": "Farm",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2368,
                              "src": "1700:4:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_struct$_Farm_$2368_storage_ptr_$",
                                "typeString": "type(struct StakerFactory.Farm storage pointer)"
                              }
                            },
                            "id": 2490,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "structConstructorCall",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "1700:75:15",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Farm_$2368_memory_ptr",
                              "typeString": "struct StakerFactory.Farm memory"
                            }
                          },
                          "src": "1691:84:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Farm_$2368_memory_ptr",
                            "typeString": "struct StakerFactory.Farm memory"
                          }
                        },
                        "id": 2492,
                        "nodeType": "ExpressionStatement",
                        "src": "1691:84:15"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 2458,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 2456,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2453,
                      "src": "1627:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 2457,
                      "name": "totalFarms",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2329,
                      "src": "1631:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1627:14:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2494,
                  "initializationExpression": {
                    "assignments": [
                      2453
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 2453,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "1620:1:15",
                        "nodeType": "VariableDeclaration",
                        "scope": 2494,
                        "src": "1615:6:15",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 2452,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "1615:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 2455,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 2454,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "1624:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "1615:10:15"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 2460,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "1643:3:15",
                      "subExpression": {
                        "id": 2459,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2453,
                        "src": "1643:1:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 2461,
                    "nodeType": "ExpressionStatement",
                    "src": "1643:3:15"
                  },
                  "nodeType": "ForStatement",
                  "src": "1611:171:15"
                },
                {
                  "expression": {
                    "id": 2495,
                    "name": "ret",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 2444,
                    "src": "1794:3:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct StakerFactory.Farm memory[] memory"
                    }
                  },
                  "functionReturnParameters": 2439,
                  "id": 2496,
                  "nodeType": "Return",
                  "src": "1787:10:15"
                }
              ]
            },
            "functionSelector": "9dc4ac8a",
            "id": 2498,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getFarms",
            "nameLocation": "1511:8:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2434,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1519:2:15"
            },
            "returnParameters": {
              "id": 2439,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2438,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2498,
                  "src": "1542:13:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                    "typeString": "struct StakerFactory.Farm[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 2436,
                      "nodeType": "UserDefinedTypeName",
                      "pathNode": {
                        "id": 2435,
                        "name": "Farm",
                        "nodeType": "IdentifierPath",
                        "referencedDeclaration": 2368,
                        "src": "1542:4:15"
                      },
                      "referencedDeclaration": 2368,
                      "src": "1542:4:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Farm_$2368_storage_ptr",
                        "typeString": "struct StakerFactory.Farm"
                      }
                    },
                    "id": 2437,
                    "nodeType": "ArrayTypeName",
                    "src": "1542:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Farm_$2368_storage_$dyn_storage_ptr",
                      "typeString": "struct StakerFactory.Farm[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1541:15:15"
            },
            "scope": 2571,
            "src": "1502:300:15",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2569,
              "nodeType": "Block",
              "src": "1872:689:15",
              "statements": [
                {
                  "assignments": [
                    2506
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2506,
                      "mutability": "mutable",
                      "name": "lastTime",
                      "nameLocation": "1938:8:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2569,
                      "src": "1933:13:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 2505,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "1933:4:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2512,
                  "initialValue": {
                    "baseExpression": {
                      "baseExpression": {
                        "id": 2507,
                        "name": "faucetTimes",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2335,
                        "src": "1949:11:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                          "typeString": "mapping(address => mapping(address => uint256))"
                        }
                      },
                      "id": 2509,
                      "indexExpression": {
                        "id": 2508,
                        "name": "_tokenAddr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2500,
                        "src": "1961:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "IndexAccess",
                      "src": "1949:23:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                        "typeString": "mapping(address => uint256)"
                      }
                    },
                    "id": 2511,
                    "indexExpression": {
                      "id": 2510,
                      "name": "_user",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2502,
                      "src": "1973:5:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "IndexAccess",
                    "src": "1949:30:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1933:46:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        "id": 2524,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 2516,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "id": 2514,
                            "name": "lastTime",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2506,
                            "src": "1994:8:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "==",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 2515,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "2006:1:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "1994:13:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "||",
                        "rightExpression": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 2523,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "components": [
                              {
                                "commonType": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                },
                                "id": 2519,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftExpression": {
                                  "id": 2517,
                                  "name": "lastTime",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2506,
                                  "src": "2012:8:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "BinaryOperation",
                                "operator": "+",
                                "rightExpression": {
                                  "id": 2518,
                                  "name": "FAUCET_TIME",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2338,
                                  "src": "2023:11:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "2012:22:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              }
                            ],
                            "id": 2520,
                            "isConstant": false,
                            "isInlineArray": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "TupleExpression",
                            "src": "2011:24:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "<",
                          "rightExpression": {
                            "expression": {
                              "id": 2521,
                              "name": "block",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 4294967292,
                              "src": "2038:5:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_magic_block",
                                "typeString": "block"
                              }
                            },
                            "id": 2522,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "timestamp",
                            "nodeType": "MemberAccess",
                            "src": "2038:15:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "2011:42:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "src": "1994:59:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "596f752063616e6e6f7420676574206d6f726520746f6b656e73206e6f77",
                        "id": 2525,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2055:32:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c",
                          "typeString": "literal_string \"You cannot get more tokens now\""
                        },
                        "value": "You cannot get more tokens now"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c",
                          "typeString": "literal_string \"You cannot get more tokens now\""
                        }
                      ],
                      "id": 2513,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1985:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2526,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1985:103:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2527,
                  "nodeType": "ExpressionStatement",
                  "src": "1985:103:15"
                },
                {
                  "expression": {
                    "id": 2535,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "baseExpression": {
                          "id": 2528,
                          "name": "faucetTimes",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2335,
                          "src": "2094:11:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                            "typeString": "mapping(address => mapping(address => uint256))"
                          }
                        },
                        "id": 2531,
                        "indexExpression": {
                          "id": 2529,
                          "name": "_tokenAddr",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2500,
                          "src": "2106:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "IndexAccess",
                        "src": "2094:23:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                          "typeString": "mapping(address => uint256)"
                        }
                      },
                      "id": 2532,
                      "indexExpression": {
                        "id": 2530,
                        "name": "_user",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2502,
                        "src": "2118:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "2094:30:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "expression": {
                        "id": 2533,
                        "name": "block",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 4294967292,
                        "src": "2127:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_block",
                          "typeString": "block"
                        }
                      },
                      "id": 2534,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "timestamp",
                      "nodeType": "MemberAccess",
                      "src": "2127:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2094:48:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2536,
                  "nodeType": "ExpressionStatement",
                  "src": "2094:48:15"
                },
                {
                  "assignments": [
                    2539
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2539,
                      "mutability": "mutable",
                      "name": "_token",
                      "nameLocation": "2155:6:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2569,
                      "src": "2148:13:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_contract$_IToken_$1822",
                        "typeString": "contract IToken"
                      },
                      "typeName": {
                        "id": 2538,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2537,
                          "name": "IToken",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 1822,
                          "src": "2148:6:15"
                        },
                        "referencedDeclaration": 1822,
                        "src": "2148:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2543,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2541,
                        "name": "_tokenAddr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2500,
                        "src": "2171:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2540,
                      "name": "IToken",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1822,
                      "src": "2164:6:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_contract$_IToken_$1822_$",
                        "typeString": "type(contract IToken)"
                      }
                    },
                    "id": 2542,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2164:18:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IToken_$1822",
                      "typeString": "contract IToken"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "2148:34:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        "id": 2552,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "arguments": [],
                          "expression": {
                            "argumentTypes": [],
                            "expression": {
                              "id": 2545,
                              "name": "_token",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2539,
                              "src": "2196:6:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_IToken_$1822",
                                "typeString": "contract IToken"
                              }
                            },
                            "id": 2546,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "owner",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 1804,
                            "src": "2196:12:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_external_nonpayable$__$returns$_t_address_$",
                              "typeString": "function () external returns (address)"
                            }
                          },
                          "id": 2547,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2196:14:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "arguments": [
                            {
                              "id": 2550,
                              "name": "this",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 4294967268,
                              "src": "2222:4:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_StakerFactory_$2571",
                                "typeString": "contract StakerFactory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_contract$_StakerFactory_$2571",
                                "typeString": "contract StakerFactory"
                              }
                            ],
                            "id": 2549,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "nodeType": "ElementaryTypeNameExpression",
                            "src": "2214:7:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_address_$",
                              "typeString": "type(address)"
                            },
                            "typeName": {
                              "id": 2548,
                              "name": "address",
                              "nodeType": "ElementaryTypeName",
                              "src": "2214:7:15",
                              "typeDescriptions": {}
                            }
                          },
                          "id": 2551,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "typeConversion",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2214:13:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "src": "2196:31:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "43616e6e6f742066617563657420746865736520746f6b656e7320746f2075736572",
                        "id": 2553,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2229:36:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec",
                          "typeString": "literal_string \"Cannot faucet these tokens to user\""
                        },
                        "value": "Cannot faucet these tokens to user"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec",
                          "typeString": "literal_string \"Cannot faucet these tokens to user\""
                        }
                      ],
                      "id": 2544,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2188:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2554,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2188:78:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2555,
                  "nodeType": "ExpressionStatement",
                  "src": "2188:78:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2559,
                        "name": "_user",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2502,
                        "src": "2456:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2560,
                        "name": "FAUCET_AMOUNT",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2345,
                        "src": "2463:13:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 2556,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2539,
                        "src": "2444:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "id": 2558,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "mint",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1811,
                      "src": "2444:11:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        "typeString": "function (address,uint256) external"
                      }
                    },
                    "id": 2561,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2444:33:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2562,
                  "nodeType": "ExpressionStatement",
                  "src": "2444:33:15"
                },
                {
                  "eventCall": {
                    "arguments": [
                      {
                        "id": 2564,
                        "name": "_tokenAddr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2500,
                        "src": "2523:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2565,
                        "name": "_user",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2502,
                        "src": "2535:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2566,
                        "name": "FAUCET_AMOUNT",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2345,
                        "src": "2542:13:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2563,
                      "name": "FacetTokensToUser",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2353,
                      "src": "2505:17:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
                        "typeString": "function (address,address,uint256)"
                      }
                    },
                    "id": 2567,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2505:51:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2568,
                  "nodeType": "EmitStatement",
                  "src": "2500:56:15"
                }
              ]
            },
            "functionSelector": "550c9fd7",
            "id": 2570,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "faucetTokens",
            "nameLocation": "1815:12:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2503,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2500,
                  "mutability": "mutable",
                  "name": "_tokenAddr",
                  "nameLocation": "1836:10:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2570,
                  "src": "1828:18:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2499,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "1828:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2502,
                  "mutability": "mutable",
                  "name": "_user",
                  "nameLocation": "1856:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2570,
                  "src": "1848:13:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2501,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "1848:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1827:35:15"
            },
            "returnParameters": {
              "id": 2504,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1872:0:15"
            },
            "scope": 2571,
            "src": "1806:755:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          }
        ],
        "scope": 2572,
        "src": "281:2282:15",
        "usedErrors": []
      }
    ],
    "src": "32:2532:15"
  },
  "legacyAST": {
    "absolutePath": "project:/contracts/StakerFactory.sol",
    "exportedSymbols": {
      "Context": [
        1154
      ],
      "IERC20": [
        1107
      ],
      "IToken": [
        1822
      ],
      "Ownable": [
        483
      ],
      "SafeMath": [
        1705
      ],
      "Staker": [
        2311
      ],
      "StakerFactory": [
        2571
      ]
    },
    "id": 2572,
    "license": "MIT",
    "nodeType": "SourceUnit",
    "nodes": [
      {
        "id": 2313,
        "literals": [
          "solidity",
          ">=",
          "0.4",
          ".22",
          "<",
          "0.9",
          ".0"
        ],
        "nodeType": "PragmaDirective",
        "src": "32:32:15"
      },
      {
        "absolutePath": "@openzeppelin/contracts/access/Ownable.sol",
        "file": "@openzeppelin/contracts/access/Ownable.sol",
        "id": 2314,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 484,
        "src": "66:52:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/utils/math/SafeMath.sol",
        "file": "@openzeppelin/contracts/utils/math/SafeMath.sol",
        "id": 2315,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 1706,
        "src": "119:57:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "@openzeppelin/contracts/token/ERC20/IERC20.sol",
        "file": "@openzeppelin/contracts/token/ERC20/IERC20.sol",
        "id": 2316,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 1108,
        "src": "177:56:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "project:/contracts/Staker.sol",
        "file": "./Staker.sol",
        "id": 2317,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 2312,
        "src": "234:22:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "absolutePath": "project:/contracts/IToken.sol",
        "file": "./IToken.sol",
        "id": 2318,
        "nameLocation": "-1:-1:-1",
        "nodeType": "ImportDirective",
        "scope": 2572,
        "sourceUnit": 1823,
        "src": "257:22:15",
        "symbolAliases": [],
        "unitAlias": ""
      },
      {
        "abstract": false,
        "baseContracts": [
          {
            "baseName": {
              "id": 2319,
              "name": "Ownable",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 483,
              "src": "307:7:15"
            },
            "id": 2320,
            "nodeType": "InheritanceSpecifier",
            "src": "307:7:15"
          }
        ],
        "contractDependencies": [
          2311
        ],
        "contractKind": "contract",
        "fullyImplemented": true,
        "id": 2571,
        "linearizedBaseContracts": [
          2571,
          483,
          1154
        ],
        "name": "StakerFactory",
        "nameLocation": "290:13:15",
        "nodeType": "ContractDefinition",
        "nodes": [
          {
            "id": 2323,
            "libraryName": {
              "id": 2321,
              "name": "SafeMath",
              "nodeType": "IdentifierPath",
              "referencedDeclaration": 1705,
              "src": "325:8:15"
            },
            "nodeType": "UsingForDirective",
            "src": "319:24:15",
            "typeName": {
              "id": 2322,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "338:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            }
          },
          {
            "constant": false,
            "functionSelector": "7da470ea",
            "id": 2327,
            "mutability": "mutable",
            "name": "farms",
            "nameLocation": "435:5:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "402:38:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
              "typeString": "mapping(uint256 => address)"
            },
            "typeName": {
              "id": 2326,
              "keyType": {
                "id": 2324,
                "name": "uint",
                "nodeType": "ElementaryTypeName",
                "src": "411:4:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                }
              },
              "nodeType": "Mapping",
              "src": "402:25:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                "typeString": "mapping(uint256 => address)"
              },
              "valueType": {
                "id": 2325,
                "name": "address",
                "nodeType": "ElementaryTypeName",
                "src": "419:7:15",
                "stateMutability": "nonpayable",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "4c995a7f",
            "id": 2329,
            "mutability": "mutable",
            "name": "totalFarms",
            "nameLocation": "456:10:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "444:22:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 2328,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "444:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "c8da3865",
            "id": 2335,
            "mutability": "mutable",
            "name": "faucetTimes",
            "nameLocation": "522:11:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "470:63:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
              "typeString": "mapping(address => mapping(address => uint256))"
            },
            "typeName": {
              "id": 2334,
              "keyType": {
                "id": 2330,
                "name": "address",
                "nodeType": "ElementaryTypeName",
                "src": "478:7:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                }
              },
              "nodeType": "Mapping",
              "src": "470:44:15",
              "typeDescriptions": {
                "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                "typeString": "mapping(address => mapping(address => uint256))"
              },
              "valueType": {
                "id": 2333,
                "keyType": {
                  "id": 2331,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "497:7:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "nodeType": "Mapping",
                "src": "489:24:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                  "typeString": "mapping(address => uint256)"
                },
                "valueType": {
                  "id": 2332,
                  "name": "uint",
                  "nodeType": "ElementaryTypeName",
                  "src": "508:4:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  }
                }
              }
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "6bcfa4f9",
            "id": 2338,
            "mutability": "mutable",
            "name": "FAUCET_TIME",
            "nameLocation": "549:11:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "537:32:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 2336,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "537:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "hexValue": "31",
              "id": 2337,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "kind": "number",
              "lValueRequested": false,
              "nodeType": "Literal",
              "src": "563:6:15",
              "subdenomination": "days",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_86400_by_1",
                "typeString": "int_const 86400"
              },
              "value": "1"
            },
            "visibility": "public"
          },
          {
            "constant": false,
            "functionSelector": "76697640",
            "id": 2345,
            "mutability": "mutable",
            "name": "FAUCET_AMOUNT",
            "nameLocation": "623:13:15",
            "nodeType": "VariableDeclaration",
            "scope": 2571,
            "src": "611:41:15",
            "stateVariable": true,
            "storageLocation": "default",
            "typeDescriptions": {
              "typeIdentifier": "t_uint256",
              "typeString": "uint256"
            },
            "typeName": {
              "id": 2339,
              "name": "uint",
              "nodeType": "ElementaryTypeName",
              "src": "611:4:15",
              "typeDescriptions": {
                "typeIdentifier": "t_uint256",
                "typeString": "uint256"
              }
            },
            "value": {
              "commonType": {
                "typeIdentifier": "t_rational_1000000000000000000000_by_1",
                "typeString": "int_const 1000000000000000000000"
              },
              "id": 2344,
              "isConstant": false,
              "isLValue": false,
              "isPure": true,
              "lValueRequested": false,
              "leftExpression": {
                "hexValue": "31303030",
                "id": 2340,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "kind": "number",
                "lValueRequested": false,
                "nodeType": "Literal",
                "src": "639:4:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_1000_by_1",
                  "typeString": "int_const 1000"
                },
                "value": "1000"
              },
              "nodeType": "BinaryOperation",
              "operator": "*",
              "rightExpression": {
                "commonType": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                },
                "id": 2343,
                "isConstant": false,
                "isLValue": false,
                "isPure": true,
                "lValueRequested": false,
                "leftExpression": {
                  "hexValue": "3130",
                  "id": 2341,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "646:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_10_by_1",
                    "typeString": "int_const 10"
                  },
                  "value": "10"
                },
                "nodeType": "BinaryOperation",
                "operator": "**",
                "rightExpression": {
                  "hexValue": "3138",
                  "id": 2342,
                  "isConstant": false,
                  "isLValue": false,
                  "isPure": true,
                  "kind": "number",
                  "lValueRequested": false,
                  "nodeType": "Literal",
                  "src": "650:2:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_rational_18_by_1",
                    "typeString": "int_const 18"
                  },
                  "value": "18"
                },
                "src": "646:6:15",
                "typeDescriptions": {
                  "typeIdentifier": "t_rational_1000000000000000000_by_1",
                  "typeString": "int_const 1000000000000000000"
                }
              },
              "src": "639:13:15",
              "typeDescriptions": {
                "typeIdentifier": "t_rational_1000000000000000000000_by_1",
                "typeString": "int_const 1000000000000000000000"
              }
            },
            "visibility": "public"
          },
          {
            "anonymous": false,
            "id": 2353,
            "name": "FacetTokensToUser",
            "nameLocation": "698:17:15",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 2352,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2347,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "_token",
                  "nameLocation": "732:6:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2353,
                  "src": "716:22:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2346,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "716:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2349,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "_user",
                  "nameLocation": "756:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2353,
                  "src": "740:21:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2348,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "740:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2351,
                  "indexed": false,
                  "mutability": "mutable",
                  "name": "_amount",
                  "nameLocation": "768:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2353,
                  "src": "763:12:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2350,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "763:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "715:61:15"
            },
            "src": "692:85:15"
          },
          {
            "anonymous": false,
            "id": 2357,
            "name": "FarmAdded",
            "nameLocation": "786:9:15",
            "nodeType": "EventDefinition",
            "parameters": {
              "id": 2356,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2355,
                  "indexed": true,
                  "mutability": "mutable",
                  "name": "_stakeAddress",
                  "nameLocation": "812:13:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2357,
                  "src": "796:29:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2354,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "796:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "795:31:15"
            },
            "src": "780:47:15"
          },
          {
            "canonicalName": "StakerFactory.Farm",
            "id": 2368,
            "members": [
              {
                "constant": false,
                "id": 2359,
                "mutability": "mutable",
                "name": "farm",
                "nameLocation": "857:4:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "849:12:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                },
                "typeName": {
                  "id": 2358,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "849:7:15",
                  "stateMutability": "nonpayable",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2361,
                "mutability": "mutable",
                "name": "stake",
                "nameLocation": "875:5:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "867:13:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                },
                "typeName": {
                  "id": 2360,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "867:7:15",
                  "stateMutability": "nonpayable",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2363,
                "mutability": "mutable",
                "name": "reward",
                "nameLocation": "894:6:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "886:14:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_address",
                  "typeString": "address"
                },
                "typeName": {
                  "id": 2362,
                  "name": "address",
                  "nodeType": "ElementaryTypeName",
                  "src": "886:7:15",
                  "stateMutability": "nonpayable",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2365,
                "mutability": "mutable",
                "name": "startTime",
                "nameLocation": "911:9:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "906:14:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                },
                "typeName": {
                  "id": 2364,
                  "name": "uint",
                  "nodeType": "ElementaryTypeName",
                  "src": "906:4:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  }
                },
                "visibility": "internal"
              },
              {
                "constant": false,
                "id": 2367,
                "mutability": "mutable",
                "name": "endTime",
                "nameLocation": "931:7:15",
                "nodeType": "VariableDeclaration",
                "scope": 2368,
                "src": "926:12:15",
                "stateVariable": false,
                "storageLocation": "default",
                "typeDescriptions": {
                  "typeIdentifier": "t_uint256",
                  "typeString": "uint256"
                },
                "typeName": {
                  "id": 2366,
                  "name": "uint",
                  "nodeType": "ElementaryTypeName",
                  "src": "926:4:15",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  }
                },
                "visibility": "internal"
              }
            ],
            "name": "Farm",
            "nameLocation": "838:4:15",
            "nodeType": "StructDefinition",
            "scope": 2571,
            "src": "831:112:15",
            "visibility": "public"
          },
          {
            "body": {
              "id": 2432,
              "nodeType": "Block",
              "src": "1048:450:15",
              "statements": [
                {
                  "assignments": [
                    2383
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2383,
                      "mutability": "mutable",
                      "name": "staker",
                      "nameLocation": "1167:6:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2432,
                      "src": "1160:13:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_contract$_Staker_$2311",
                        "typeString": "contract Staker"
                      },
                      "typeName": {
                        "id": 2382,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2381,
                          "name": "Staker",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 2311,
                          "src": "1160:6:15"
                        },
                        "referencedDeclaration": 2311,
                        "src": "1160:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Staker_$2311",
                          "typeString": "contract Staker"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2392,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2387,
                        "name": "_tokenA",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2370,
                        "src": "1187:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2388,
                        "name": "_tokenB",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2372,
                        "src": "1196:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2389,
                        "name": "startTime",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2374,
                        "src": "1205:9:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      {
                        "id": 2390,
                        "name": "endTime",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2376,
                        "src": "1216:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2386,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "NewExpression",
                      "src": "1176:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_creation_nonpayable$_t_address_$_t_address_$_t_uint256_$_t_uint256_$returns$_t_contract$_Staker_$2311_$",
                        "typeString": "function (address,address,uint256,uint256) returns (contract Staker)"
                      },
                      "typeName": {
                        "id": 2385,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2384,
                          "name": "Staker",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 2311,
                          "src": "1180:6:15"
                        },
                        "referencedDeclaration": 2311,
                        "src": "1180:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_Staker_$2311",
                          "typeString": "contract Staker"
                        }
                      }
                    },
                    "id": 2391,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1176:48:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_Staker_$2311",
                      "typeString": "contract Staker"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1160:64:15"
                },
                {
                  "expression": {
                    "id": 2400,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "id": 2393,
                        "name": "farms",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2327,
                        "src": "1230:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                          "typeString": "mapping(uint256 => address)"
                        }
                      },
                      "id": 2395,
                      "indexExpression": {
                        "id": 2394,
                        "name": "totalFarms",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2329,
                        "src": "1236:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "1230:17:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "arguments": [
                        {
                          "id": 2398,
                          "name": "staker",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2383,
                          "src": "1258:6:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_contract$_Staker_$2311",
                            "typeString": "contract Staker"
                          }
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_contract$_Staker_$2311",
                            "typeString": "contract Staker"
                          }
                        ],
                        "id": 2397,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "lValueRequested": false,
                        "nodeType": "ElementaryTypeNameExpression",
                        "src": "1250:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_type$_t_address_$",
                          "typeString": "type(address)"
                        },
                        "typeName": {
                          "id": 2396,
                          "name": "address",
                          "nodeType": "ElementaryTypeName",
                          "src": "1250:7:15",
                          "typeDescriptions": {}
                        }
                      },
                      "id": 2399,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "typeConversion",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1250:15:15",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "src": "1230:35:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "id": 2401,
                  "nodeType": "ExpressionStatement",
                  "src": "1230:35:15"
                },
                {
                  "assignments": [
                    2404
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2404,
                      "mutability": "mutable",
                      "name": "it",
                      "nameLocation": "1351:2:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2432,
                      "src": "1344:9:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_contract$_IToken_$1822",
                        "typeString": "contract IToken"
                      },
                      "typeName": {
                        "id": 2403,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2402,
                          "name": "IToken",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 1822,
                          "src": "1344:6:15"
                        },
                        "referencedDeclaration": 1822,
                        "src": "1344:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2408,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2406,
                        "name": "_tokenB",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2372,
                        "src": "1363:7:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2405,
                      "name": "IToken",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1822,
                      "src": "1356:6:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_contract$_IToken_$1822_$",
                        "typeString": "type(contract IToken)"
                      }
                    },
                    "id": 2407,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1356:15:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IToken_$1822",
                      "typeString": "contract IToken"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1344:27:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2414,
                            "name": "staker",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2383,
                            "src": "1412:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          ],
                          "id": 2413,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "1404:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 2412,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "1404:7:15",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 2415,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "1404:15:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "expression": {
                        "id": 2409,
                        "name": "it",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2404,
                        "src": "1377:2:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "id": 2411,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "addContractToMinterRole",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1816,
                      "src": "1377:26:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$returns$__$",
                        "typeString": "function (address) external"
                      }
                    },
                    "id": 2416,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1377:43:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2417,
                  "nodeType": "ExpressionStatement",
                  "src": "1377:43:15"
                },
                {
                  "expression": {
                    "id": 2423,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "id": 2418,
                      "name": "totalFarms",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2329,
                      "src": "1426:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "arguments": [
                        {
                          "hexValue": "31",
                          "id": 2421,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "kind": "number",
                          "lValueRequested": false,
                          "nodeType": "Literal",
                          "src": "1454:1:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_rational_1_by_1",
                            "typeString": "int_const 1"
                          },
                          "value": "1"
                        }
                      ],
                      "expression": {
                        "argumentTypes": [
                          {
                            "typeIdentifier": "t_rational_1_by_1",
                            "typeString": "int_const 1"
                          }
                        ],
                        "expression": {
                          "id": 2419,
                          "name": "totalFarms",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2329,
                          "src": "1439:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "id": 2420,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "memberName": "add",
                        "nodeType": "MemberAccess",
                        "referencedDeclaration": 1569,
                        "src": "1439:14:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_function_internal_pure$_t_uint256_$_t_uint256_$returns$_t_uint256_$bound_to$_t_uint256_$",
                          "typeString": "function (uint256,uint256) pure returns (uint256)"
                        }
                      },
                      "id": 2422,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "kind": "functionCall",
                      "lValueRequested": false,
                      "names": [],
                      "nodeType": "FunctionCall",
                      "src": "1439:17:15",
                      "tryCall": false,
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1426:30:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2424,
                  "nodeType": "ExpressionStatement",
                  "src": "1426:30:15"
                },
                {
                  "eventCall": {
                    "arguments": [
                      {
                        "arguments": [
                          {
                            "id": 2428,
                            "name": "staker",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2383,
                            "src": "1485:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          }
                        ],
                        "expression": {
                          "argumentTypes": [
                            {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            }
                          ],
                          "id": 2427,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": true,
                          "lValueRequested": false,
                          "nodeType": "ElementaryTypeNameExpression",
                          "src": "1477:7:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_type$_t_address_$",
                            "typeString": "type(address)"
                          },
                          "typeName": {
                            "id": 2426,
                            "name": "address",
                            "nodeType": "ElementaryTypeName",
                            "src": "1477:7:15",
                            "typeDescriptions": {}
                          }
                        },
                        "id": 2429,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "kind": "typeConversion",
                        "lValueRequested": false,
                        "names": [],
                        "nodeType": "FunctionCall",
                        "src": "1477:15:15",
                        "tryCall": false,
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2425,
                      "name": "FarmAdded",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2357,
                      "src": "1467:9:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_event_nonpayable$_t_address_$returns$__$",
                        "typeString": "function (address)"
                      }
                    },
                    "id": 2430,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1467:26:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2431,
                  "nodeType": "EmitStatement",
                  "src": "1462:31:15"
                }
              ]
            },
            "functionSelector": "4febcb34",
            "id": 2433,
            "implemented": true,
            "kind": "function",
            "modifiers": [
              {
                "id": 2379,
                "kind": "modifierInvocation",
                "modifierName": {
                  "id": 2378,
                  "name": "onlyOwner",
                  "nodeType": "IdentifierPath",
                  "referencedDeclaration": 426,
                  "src": "1038:9:15"
                },
                "nodeType": "ModifierInvocation",
                "src": "1038:9:15"
              }
            ],
            "name": "createFarm",
            "nameLocation": "956:10:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2377,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2370,
                  "mutability": "mutable",
                  "name": "_tokenA",
                  "nameLocation": "975:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "967:15:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2369,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "967:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2372,
                  "mutability": "mutable",
                  "name": "_tokenB",
                  "nameLocation": "992:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "984:15:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2371,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "984:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2374,
                  "mutability": "mutable",
                  "name": "startTime",
                  "nameLocation": "1006:9:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "1001:14:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2373,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1001:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2376,
                  "mutability": "mutable",
                  "name": "endTime",
                  "nameLocation": "1022:7:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2433,
                  "src": "1017:12:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_uint256",
                    "typeString": "uint256"
                  },
                  "typeName": {
                    "id": 2375,
                    "name": "uint",
                    "nodeType": "ElementaryTypeName",
                    "src": "1017:4:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "966:64:15"
            },
            "returnParameters": {
              "id": 2380,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1048:0:15"
            },
            "scope": 2571,
            "src": "947:551:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2497,
              "nodeType": "Block",
              "src": "1557:245:15",
              "statements": [
                {
                  "assignments": [
                    2444
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2444,
                      "mutability": "mutable",
                      "name": "ret",
                      "nameLocation": "1577:3:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2497,
                      "src": "1563:17:15",
                      "stateVariable": false,
                      "storageLocation": "memory",
                      "typeDescriptions": {
                        "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                        "typeString": "struct StakerFactory.Farm[]"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 2442,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 2441,
                            "name": "Farm",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2368,
                            "src": "1563:4:15"
                          },
                          "referencedDeclaration": 2368,
                          "src": "1563:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Farm_$2368_storage_ptr",
                            "typeString": "struct StakerFactory.Farm"
                          }
                        },
                        "id": 2443,
                        "nodeType": "ArrayTypeName",
                        "src": "1563:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Farm_$2368_storage_$dyn_storage_ptr",
                          "typeString": "struct StakerFactory.Farm[]"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2451,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2449,
                        "name": "totalFarms",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2329,
                        "src": "1594:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2448,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "lValueRequested": false,
                      "nodeType": "NewExpression",
                      "src": "1583:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_objectcreation_pure$_t_uint256_$returns$_t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr_$",
                        "typeString": "function (uint256) pure returns (struct StakerFactory.Farm memory[] memory)"
                      },
                      "typeName": {
                        "baseType": {
                          "id": 2446,
                          "nodeType": "UserDefinedTypeName",
                          "pathNode": {
                            "id": 2445,
                            "name": "Farm",
                            "nodeType": "IdentifierPath",
                            "referencedDeclaration": 2368,
                            "src": "1587:4:15"
                          },
                          "referencedDeclaration": 2368,
                          "src": "1587:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Farm_$2368_storage_ptr",
                            "typeString": "struct StakerFactory.Farm"
                          }
                        },
                        "id": 2447,
                        "nodeType": "ArrayTypeName",
                        "src": "1587:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_array$_t_struct$_Farm_$2368_storage_$dyn_storage_ptr",
                          "typeString": "struct StakerFactory.Farm[]"
                        }
                      }
                    },
                    "id": 2450,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1583:22:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct StakerFactory.Farm memory[] memory"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1563:42:15"
                },
                {
                  "body": {
                    "id": 2493,
                    "nodeType": "Block",
                    "src": "1648:134:15",
                    "statements": [
                      {
                        "assignments": [
                          2464
                        ],
                        "declarations": [
                          {
                            "constant": false,
                            "id": 2464,
                            "mutability": "mutable",
                            "name": "s",
                            "nameLocation": "1663:1:15",
                            "nodeType": "VariableDeclaration",
                            "scope": 2493,
                            "src": "1656:8:15",
                            "stateVariable": false,
                            "storageLocation": "default",
                            "typeDescriptions": {
                              "typeIdentifier": "t_contract$_Staker_$2311",
                              "typeString": "contract Staker"
                            },
                            "typeName": {
                              "id": 2463,
                              "nodeType": "UserDefinedTypeName",
                              "pathNode": {
                                "id": 2462,
                                "name": "Staker",
                                "nodeType": "IdentifierPath",
                                "referencedDeclaration": 2311,
                                "src": "1656:6:15"
                              },
                              "referencedDeclaration": 2311,
                              "src": "1656:6:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_Staker_$2311",
                                "typeString": "contract Staker"
                              }
                            },
                            "visibility": "internal"
                          }
                        ],
                        "id": 2470,
                        "initialValue": {
                          "arguments": [
                            {
                              "baseExpression": {
                                "id": 2466,
                                "name": "farms",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 2327,
                                "src": "1674:5:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                                  "typeString": "mapping(uint256 => address)"
                                }
                              },
                              "id": 2468,
                              "indexExpression": {
                                "id": 2467,
                                "name": "i",
                                "nodeType": "Identifier",
                                "overloadedDeclarations": [],
                                "referencedDeclaration": 2453,
                                "src": "1680:1:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              "isConstant": false,
                              "isLValue": true,
                              "isPure": false,
                              "lValueRequested": false,
                              "nodeType": "IndexAccess",
                              "src": "1674:8:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_address",
                                "typeString": "address"
                              }
                            ],
                            "id": 2465,
                            "name": "Staker",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2311,
                            "src": "1667:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_contract$_Staker_$2311_$",
                              "typeString": "type(contract Staker)"
                            }
                          },
                          "id": 2469,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "typeConversion",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "1667:16:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_contract$_Staker_$2311",
                            "typeString": "contract Staker"
                          }
                        },
                        "nodeType": "VariableDeclarationStatement",
                        "src": "1656:27:15"
                      },
                      {
                        "expression": {
                          "id": 2491,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftHandSide": {
                            "baseExpression": {
                              "id": 2471,
                              "name": "ret",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2444,
                              "src": "1691:3:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                                "typeString": "struct StakerFactory.Farm memory[] memory"
                              }
                            },
                            "id": 2473,
                            "indexExpression": {
                              "id": 2472,
                              "name": "i",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2453,
                              "src": "1695:1:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_uint256",
                                "typeString": "uint256"
                              }
                            },
                            "isConstant": false,
                            "isLValue": true,
                            "isPure": false,
                            "lValueRequested": true,
                            "nodeType": "IndexAccess",
                            "src": "1691:6:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Farm_$2368_memory_ptr",
                              "typeString": "struct StakerFactory.Farm memory"
                            }
                          },
                          "nodeType": "Assignment",
                          "operator": "=",
                          "rightHandSide": {
                            "arguments": [
                              {
                                "baseExpression": {
                                  "id": 2475,
                                  "name": "farms",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2327,
                                  "src": "1705:5:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_mapping$_t_uint256_$_t_address_$",
                                    "typeString": "mapping(uint256 => address)"
                                  }
                                },
                                "id": 2477,
                                "indexExpression": {
                                  "id": 2476,
                                  "name": "i",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2453,
                                  "src": "1711:1:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "isConstant": false,
                                "isLValue": true,
                                "isPure": false,
                                "lValueRequested": false,
                                "nodeType": "IndexAccess",
                                "src": "1705:8:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2478,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1715:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2479,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "stakeToken",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1868,
                                  "src": "1715:12:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_address_$",
                                    "typeString": "function () view external returns (address)"
                                  }
                                },
                                "id": 2480,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1715:14:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2481,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1731:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2482,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "rewardToken",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1870,
                                  "src": "1731:13:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_address_$",
                                    "typeString": "function () view external returns (address)"
                                  }
                                },
                                "id": 2483,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1731:15:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2484,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1748:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2485,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "startTime",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1872,
                                  "src": "1748:11:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
                                    "typeString": "function () view external returns (uint256)"
                                  }
                                },
                                "id": 2486,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1748:13:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              },
                              {
                                "arguments": [],
                                "expression": {
                                  "argumentTypes": [],
                                  "expression": {
                                    "id": 2487,
                                    "name": "s",
                                    "nodeType": "Identifier",
                                    "overloadedDeclarations": [],
                                    "referencedDeclaration": 2464,
                                    "src": "1763:1:15",
                                    "typeDescriptions": {
                                      "typeIdentifier": "t_contract$_Staker_$2311",
                                      "typeString": "contract Staker"
                                    }
                                  },
                                  "id": 2488,
                                  "isConstant": false,
                                  "isLValue": false,
                                  "isPure": false,
                                  "lValueRequested": false,
                                  "memberName": "endTime",
                                  "nodeType": "MemberAccess",
                                  "referencedDeclaration": 1874,
                                  "src": "1763:9:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_function_external_view$__$returns$_t_uint256_$",
                                    "typeString": "function () view external returns (uint256)"
                                  }
                                },
                                "id": 2489,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "kind": "functionCall",
                                "lValueRequested": false,
                                "names": [],
                                "nodeType": "FunctionCall",
                                "src": "1763:11:15",
                                "tryCall": false,
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              }
                            ],
                            "expression": {
                              "argumentTypes": [
                                {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                },
                                {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                },
                                {
                                  "typeIdentifier": "t_address",
                                  "typeString": "address"
                                },
                                {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                },
                                {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              ],
                              "id": 2474,
                              "name": "Farm",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2368,
                              "src": "1700:4:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_type$_t_struct$_Farm_$2368_storage_ptr_$",
                                "typeString": "type(struct StakerFactory.Farm storage pointer)"
                              }
                            },
                            "id": 2490,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "kind": "structConstructorCall",
                            "lValueRequested": false,
                            "names": [],
                            "nodeType": "FunctionCall",
                            "src": "1700:75:15",
                            "tryCall": false,
                            "typeDescriptions": {
                              "typeIdentifier": "t_struct$_Farm_$2368_memory_ptr",
                              "typeString": "struct StakerFactory.Farm memory"
                            }
                          },
                          "src": "1691:84:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_struct$_Farm_$2368_memory_ptr",
                            "typeString": "struct StakerFactory.Farm memory"
                          }
                        },
                        "id": 2492,
                        "nodeType": "ExpressionStatement",
                        "src": "1691:84:15"
                      }
                    ]
                  },
                  "condition": {
                    "commonType": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    },
                    "id": 2458,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftExpression": {
                      "id": 2456,
                      "name": "i",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2453,
                      "src": "1627:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "BinaryOperation",
                    "operator": "<",
                    "rightExpression": {
                      "id": 2457,
                      "name": "totalFarms",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2329,
                      "src": "1631:10:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "1627:14:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_bool",
                      "typeString": "bool"
                    }
                  },
                  "id": 2494,
                  "initializationExpression": {
                    "assignments": [
                      2453
                    ],
                    "declarations": [
                      {
                        "constant": false,
                        "id": 2453,
                        "mutability": "mutable",
                        "name": "i",
                        "nameLocation": "1620:1:15",
                        "nodeType": "VariableDeclaration",
                        "scope": 2494,
                        "src": "1615:6:15",
                        "stateVariable": false,
                        "storageLocation": "default",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        },
                        "typeName": {
                          "id": 2452,
                          "name": "uint",
                          "nodeType": "ElementaryTypeName",
                          "src": "1615:4:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          }
                        },
                        "visibility": "internal"
                      }
                    ],
                    "id": 2455,
                    "initialValue": {
                      "hexValue": "30",
                      "id": 2454,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": true,
                      "kind": "number",
                      "lValueRequested": false,
                      "nodeType": "Literal",
                      "src": "1624:1:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_rational_0_by_1",
                        "typeString": "int_const 0"
                      },
                      "value": "0"
                    },
                    "nodeType": "VariableDeclarationStatement",
                    "src": "1615:10:15"
                  },
                  "loopExpression": {
                    "expression": {
                      "id": 2460,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "UnaryOperation",
                      "operator": "++",
                      "prefix": false,
                      "src": "1643:3:15",
                      "subExpression": {
                        "id": 2459,
                        "name": "i",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2453,
                        "src": "1643:1:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "id": 2461,
                    "nodeType": "ExpressionStatement",
                    "src": "1643:3:15"
                  },
                  "nodeType": "ForStatement",
                  "src": "1611:171:15"
                },
                {
                  "expression": {
                    "id": 2495,
                    "name": "ret",
                    "nodeType": "Identifier",
                    "overloadedDeclarations": [],
                    "referencedDeclaration": 2444,
                    "src": "1794:3:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                      "typeString": "struct StakerFactory.Farm memory[] memory"
                    }
                  },
                  "functionReturnParameters": 2439,
                  "id": 2496,
                  "nodeType": "Return",
                  "src": "1787:10:15"
                }
              ]
            },
            "functionSelector": "9dc4ac8a",
            "id": 2498,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "getFarms",
            "nameLocation": "1511:8:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2434,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1519:2:15"
            },
            "returnParameters": {
              "id": 2439,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2438,
                  "mutability": "mutable",
                  "name": "",
                  "nameLocation": "-1:-1:-1",
                  "nodeType": "VariableDeclaration",
                  "scope": 2498,
                  "src": "1542:13:15",
                  "stateVariable": false,
                  "storageLocation": "memory",
                  "typeDescriptions": {
                    "typeIdentifier": "t_array$_t_struct$_Farm_$2368_memory_ptr_$dyn_memory_ptr",
                    "typeString": "struct StakerFactory.Farm[]"
                  },
                  "typeName": {
                    "baseType": {
                      "id": 2436,
                      "nodeType": "UserDefinedTypeName",
                      "pathNode": {
                        "id": 2435,
                        "name": "Farm",
                        "nodeType": "IdentifierPath",
                        "referencedDeclaration": 2368,
                        "src": "1542:4:15"
                      },
                      "referencedDeclaration": 2368,
                      "src": "1542:4:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_struct$_Farm_$2368_storage_ptr",
                        "typeString": "struct StakerFactory.Farm"
                      }
                    },
                    "id": 2437,
                    "nodeType": "ArrayTypeName",
                    "src": "1542:6:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_array$_t_struct$_Farm_$2368_storage_$dyn_storage_ptr",
                      "typeString": "struct StakerFactory.Farm[]"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1541:15:15"
            },
            "scope": 2571,
            "src": "1502:300:15",
            "stateMutability": "view",
            "virtual": false,
            "visibility": "public"
          },
          {
            "body": {
              "id": 2569,
              "nodeType": "Block",
              "src": "1872:689:15",
              "statements": [
                {
                  "assignments": [
                    2506
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2506,
                      "mutability": "mutable",
                      "name": "lastTime",
                      "nameLocation": "1938:8:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2569,
                      "src": "1933:13:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      },
                      "typeName": {
                        "id": 2505,
                        "name": "uint",
                        "nodeType": "ElementaryTypeName",
                        "src": "1933:4:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2512,
                  "initialValue": {
                    "baseExpression": {
                      "baseExpression": {
                        "id": 2507,
                        "name": "faucetTimes",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2335,
                        "src": "1949:11:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                          "typeString": "mapping(address => mapping(address => uint256))"
                        }
                      },
                      "id": 2509,
                      "indexExpression": {
                        "id": 2508,
                        "name": "_tokenAddr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2500,
                        "src": "1961:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": false,
                      "nodeType": "IndexAccess",
                      "src": "1949:23:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                        "typeString": "mapping(address => uint256)"
                      }
                    },
                    "id": 2511,
                    "indexExpression": {
                      "id": 2510,
                      "name": "_user",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2502,
                      "src": "1973:5:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_address",
                        "typeString": "address"
                      }
                    },
                    "isConstant": false,
                    "isLValue": true,
                    "isPure": false,
                    "lValueRequested": false,
                    "nodeType": "IndexAccess",
                    "src": "1949:30:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "1933:46:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        "id": 2524,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 2516,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "id": 2514,
                            "name": "lastTime",
                            "nodeType": "Identifier",
                            "overloadedDeclarations": [],
                            "referencedDeclaration": 2506,
                            "src": "1994:8:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "==",
                          "rightExpression": {
                            "hexValue": "30",
                            "id": 2515,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "kind": "number",
                            "lValueRequested": false,
                            "nodeType": "Literal",
                            "src": "2006:1:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_rational_0_by_1",
                              "typeString": "int_const 0"
                            },
                            "value": "0"
                          },
                          "src": "1994:13:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "||",
                        "rightExpression": {
                          "commonType": {
                            "typeIdentifier": "t_uint256",
                            "typeString": "uint256"
                          },
                          "id": 2523,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "lValueRequested": false,
                          "leftExpression": {
                            "components": [
                              {
                                "commonType": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                },
                                "id": 2519,
                                "isConstant": false,
                                "isLValue": false,
                                "isPure": false,
                                "lValueRequested": false,
                                "leftExpression": {
                                  "id": 2517,
                                  "name": "lastTime",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2506,
                                  "src": "2012:8:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "nodeType": "BinaryOperation",
                                "operator": "+",
                                "rightExpression": {
                                  "id": 2518,
                                  "name": "FAUCET_TIME",
                                  "nodeType": "Identifier",
                                  "overloadedDeclarations": [],
                                  "referencedDeclaration": 2338,
                                  "src": "2023:11:15",
                                  "typeDescriptions": {
                                    "typeIdentifier": "t_uint256",
                                    "typeString": "uint256"
                                  }
                                },
                                "src": "2012:22:15",
                                "typeDescriptions": {
                                  "typeIdentifier": "t_uint256",
                                  "typeString": "uint256"
                                }
                              }
                            ],
                            "id": 2520,
                            "isConstant": false,
                            "isInlineArray": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "nodeType": "TupleExpression",
                            "src": "2011:24:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "nodeType": "BinaryOperation",
                          "operator": "<",
                          "rightExpression": {
                            "expression": {
                              "id": 2521,
                              "name": "block",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 4294967292,
                              "src": "2038:5:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_magic_block",
                                "typeString": "block"
                              }
                            },
                            "id": 2522,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "timestamp",
                            "nodeType": "MemberAccess",
                            "src": "2038:15:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_uint256",
                              "typeString": "uint256"
                            }
                          },
                          "src": "2011:42:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_bool",
                            "typeString": "bool"
                          }
                        },
                        "src": "1994:59:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "596f752063616e6e6f7420676574206d6f726520746f6b656e73206e6f77",
                        "id": 2525,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2055:32:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c",
                          "typeString": "literal_string \"You cannot get more tokens now\""
                        },
                        "value": "You cannot get more tokens now"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_d9ff9fa4fda15840c3b22a1f77963d815f4d5506e2f992c26e96a0a28f81bd8c",
                          "typeString": "literal_string \"You cannot get more tokens now\""
                        }
                      ],
                      "id": 2513,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "1985:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2526,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "1985:103:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2527,
                  "nodeType": "ExpressionStatement",
                  "src": "1985:103:15"
                },
                {
                  "expression": {
                    "id": 2535,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "lValueRequested": false,
                    "leftHandSide": {
                      "baseExpression": {
                        "baseExpression": {
                          "id": 2528,
                          "name": "faucetTimes",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2335,
                          "src": "2094:11:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_mapping$_t_address_$_t_mapping$_t_address_$_t_uint256_$_$",
                            "typeString": "mapping(address => mapping(address => uint256))"
                          }
                        },
                        "id": 2531,
                        "indexExpression": {
                          "id": 2529,
                          "name": "_tokenAddr",
                          "nodeType": "Identifier",
                          "overloadedDeclarations": [],
                          "referencedDeclaration": 2500,
                          "src": "2106:10:15",
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "isConstant": false,
                        "isLValue": true,
                        "isPure": false,
                        "lValueRequested": false,
                        "nodeType": "IndexAccess",
                        "src": "2094:23:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_mapping$_t_address_$_t_uint256_$",
                          "typeString": "mapping(address => uint256)"
                        }
                      },
                      "id": 2532,
                      "indexExpression": {
                        "id": 2530,
                        "name": "_user",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2502,
                        "src": "2118:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      "isConstant": false,
                      "isLValue": true,
                      "isPure": false,
                      "lValueRequested": true,
                      "nodeType": "IndexAccess",
                      "src": "2094:30:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "nodeType": "Assignment",
                    "operator": "=",
                    "rightHandSide": {
                      "expression": {
                        "id": 2533,
                        "name": "block",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 4294967292,
                        "src": "2127:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_magic_block",
                          "typeString": "block"
                        }
                      },
                      "id": 2534,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "timestamp",
                      "nodeType": "MemberAccess",
                      "src": "2127:15:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_uint256",
                        "typeString": "uint256"
                      }
                    },
                    "src": "2094:48:15",
                    "typeDescriptions": {
                      "typeIdentifier": "t_uint256",
                      "typeString": "uint256"
                    }
                  },
                  "id": 2536,
                  "nodeType": "ExpressionStatement",
                  "src": "2094:48:15"
                },
                {
                  "assignments": [
                    2539
                  ],
                  "declarations": [
                    {
                      "constant": false,
                      "id": 2539,
                      "mutability": "mutable",
                      "name": "_token",
                      "nameLocation": "2155:6:15",
                      "nodeType": "VariableDeclaration",
                      "scope": 2569,
                      "src": "2148:13:15",
                      "stateVariable": false,
                      "storageLocation": "default",
                      "typeDescriptions": {
                        "typeIdentifier": "t_contract$_IToken_$1822",
                        "typeString": "contract IToken"
                      },
                      "typeName": {
                        "id": 2538,
                        "nodeType": "UserDefinedTypeName",
                        "pathNode": {
                          "id": 2537,
                          "name": "IToken",
                          "nodeType": "IdentifierPath",
                          "referencedDeclaration": 1822,
                          "src": "2148:6:15"
                        },
                        "referencedDeclaration": 1822,
                        "src": "2148:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "visibility": "internal"
                    }
                  ],
                  "id": 2543,
                  "initialValue": {
                    "arguments": [
                      {
                        "id": 2541,
                        "name": "_tokenAddr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2500,
                        "src": "2171:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      ],
                      "id": 2540,
                      "name": "IToken",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 1822,
                      "src": "2164:6:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_type$_t_contract$_IToken_$1822_$",
                        "typeString": "type(contract IToken)"
                      }
                    },
                    "id": 2542,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "typeConversion",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2164:18:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_contract$_IToken_$1822",
                      "typeString": "contract IToken"
                    }
                  },
                  "nodeType": "VariableDeclarationStatement",
                  "src": "2148:34:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "commonType": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        "id": 2552,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": false,
                        "lValueRequested": false,
                        "leftExpression": {
                          "arguments": [],
                          "expression": {
                            "argumentTypes": [],
                            "expression": {
                              "id": 2545,
                              "name": "_token",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 2539,
                              "src": "2196:6:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_IToken_$1822",
                                "typeString": "contract IToken"
                              }
                            },
                            "id": 2546,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": false,
                            "lValueRequested": false,
                            "memberName": "owner",
                            "nodeType": "MemberAccess",
                            "referencedDeclaration": 1804,
                            "src": "2196:12:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_function_external_nonpayable$__$returns$_t_address_$",
                              "typeString": "function () external returns (address)"
                            }
                          },
                          "id": 2547,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "functionCall",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2196:14:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "nodeType": "BinaryOperation",
                        "operator": "==",
                        "rightExpression": {
                          "arguments": [
                            {
                              "id": 2550,
                              "name": "this",
                              "nodeType": "Identifier",
                              "overloadedDeclarations": [],
                              "referencedDeclaration": 4294967268,
                              "src": "2222:4:15",
                              "typeDescriptions": {
                                "typeIdentifier": "t_contract$_StakerFactory_$2571",
                                "typeString": "contract StakerFactory"
                              }
                            }
                          ],
                          "expression": {
                            "argumentTypes": [
                              {
                                "typeIdentifier": "t_contract$_StakerFactory_$2571",
                                "typeString": "contract StakerFactory"
                              }
                            ],
                            "id": 2549,
                            "isConstant": false,
                            "isLValue": false,
                            "isPure": true,
                            "lValueRequested": false,
                            "nodeType": "ElementaryTypeNameExpression",
                            "src": "2214:7:15",
                            "typeDescriptions": {
                              "typeIdentifier": "t_type$_t_address_$",
                              "typeString": "type(address)"
                            },
                            "typeName": {
                              "id": 2548,
                              "name": "address",
                              "nodeType": "ElementaryTypeName",
                              "src": "2214:7:15",
                              "typeDescriptions": {}
                            }
                          },
                          "id": 2551,
                          "isConstant": false,
                          "isLValue": false,
                          "isPure": false,
                          "kind": "typeConversion",
                          "lValueRequested": false,
                          "names": [],
                          "nodeType": "FunctionCall",
                          "src": "2214:13:15",
                          "tryCall": false,
                          "typeDescriptions": {
                            "typeIdentifier": "t_address",
                            "typeString": "address"
                          }
                        },
                        "src": "2196:31:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        }
                      },
                      {
                        "hexValue": "43616e6e6f742066617563657420746865736520746f6b656e7320746f2075736572",
                        "id": 2553,
                        "isConstant": false,
                        "isLValue": false,
                        "isPure": true,
                        "kind": "string",
                        "lValueRequested": false,
                        "nodeType": "Literal",
                        "src": "2229:36:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec",
                          "typeString": "literal_string \"Cannot faucet these tokens to user\""
                        },
                        "value": "Cannot faucet these tokens to user"
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_bool",
                          "typeString": "bool"
                        },
                        {
                          "typeIdentifier": "t_stringliteral_8b39dbda6959e3b22bf8eaf487f385ff7130464e78873994d81a63b0bd411fec",
                          "typeString": "literal_string \"Cannot faucet these tokens to user\""
                        }
                      ],
                      "id": 2544,
                      "name": "require",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [
                        4294967278,
                        4294967278
                      ],
                      "referencedDeclaration": 4294967278,
                      "src": "2188:7:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_require_pure$_t_bool_$_t_string_memory_ptr_$returns$__$",
                        "typeString": "function (bool,string memory) pure"
                      }
                    },
                    "id": 2554,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2188:78:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2555,
                  "nodeType": "ExpressionStatement",
                  "src": "2188:78:15"
                },
                {
                  "expression": {
                    "arguments": [
                      {
                        "id": 2559,
                        "name": "_user",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2502,
                        "src": "2456:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2560,
                        "name": "FAUCET_AMOUNT",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2345,
                        "src": "2463:13:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "expression": {
                        "id": 2556,
                        "name": "_token",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2539,
                        "src": "2444:6:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_contract$_IToken_$1822",
                          "typeString": "contract IToken"
                        }
                      },
                      "id": 2558,
                      "isConstant": false,
                      "isLValue": false,
                      "isPure": false,
                      "lValueRequested": false,
                      "memberName": "mint",
                      "nodeType": "MemberAccess",
                      "referencedDeclaration": 1811,
                      "src": "2444:11:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_external_nonpayable$_t_address_$_t_uint256_$returns$__$",
                        "typeString": "function (address,uint256) external"
                      }
                    },
                    "id": 2561,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2444:33:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2562,
                  "nodeType": "ExpressionStatement",
                  "src": "2444:33:15"
                },
                {
                  "eventCall": {
                    "arguments": [
                      {
                        "id": 2564,
                        "name": "_tokenAddr",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2500,
                        "src": "2523:10:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2565,
                        "name": "_user",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2502,
                        "src": "2535:5:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        }
                      },
                      {
                        "id": 2566,
                        "name": "FAUCET_AMOUNT",
                        "nodeType": "Identifier",
                        "overloadedDeclarations": [],
                        "referencedDeclaration": 2345,
                        "src": "2542:13:15",
                        "typeDescriptions": {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      }
                    ],
                    "expression": {
                      "argumentTypes": [
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_address",
                          "typeString": "address"
                        },
                        {
                          "typeIdentifier": "t_uint256",
                          "typeString": "uint256"
                        }
                      ],
                      "id": 2563,
                      "name": "FacetTokensToUser",
                      "nodeType": "Identifier",
                      "overloadedDeclarations": [],
                      "referencedDeclaration": 2353,
                      "src": "2505:17:15",
                      "typeDescriptions": {
                        "typeIdentifier": "t_function_event_nonpayable$_t_address_$_t_address_$_t_uint256_$returns$__$",
                        "typeString": "function (address,address,uint256)"
                      }
                    },
                    "id": 2567,
                    "isConstant": false,
                    "isLValue": false,
                    "isPure": false,
                    "kind": "functionCall",
                    "lValueRequested": false,
                    "names": [],
                    "nodeType": "FunctionCall",
                    "src": "2505:51:15",
                    "tryCall": false,
                    "typeDescriptions": {
                      "typeIdentifier": "t_tuple$__$",
                      "typeString": "tuple()"
                    }
                  },
                  "id": 2568,
                  "nodeType": "EmitStatement",
                  "src": "2500:56:15"
                }
              ]
            },
            "functionSelector": "550c9fd7",
            "id": 2570,
            "implemented": true,
            "kind": "function",
            "modifiers": [],
            "name": "faucetTokens",
            "nameLocation": "1815:12:15",
            "nodeType": "FunctionDefinition",
            "parameters": {
              "id": 2503,
              "nodeType": "ParameterList",
              "parameters": [
                {
                  "constant": false,
                  "id": 2500,
                  "mutability": "mutable",
                  "name": "_tokenAddr",
                  "nameLocation": "1836:10:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2570,
                  "src": "1828:18:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2499,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "1828:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                },
                {
                  "constant": false,
                  "id": 2502,
                  "mutability": "mutable",
                  "name": "_user",
                  "nameLocation": "1856:5:15",
                  "nodeType": "VariableDeclaration",
                  "scope": 2570,
                  "src": "1848:13:15",
                  "stateVariable": false,
                  "storageLocation": "default",
                  "typeDescriptions": {
                    "typeIdentifier": "t_address",
                    "typeString": "address"
                  },
                  "typeName": {
                    "id": 2501,
                    "name": "address",
                    "nodeType": "ElementaryTypeName",
                    "src": "1848:7:15",
                    "stateMutability": "nonpayable",
                    "typeDescriptions": {
                      "typeIdentifier": "t_address",
                      "typeString": "address"
                    }
                  },
                  "visibility": "internal"
                }
              ],
              "src": "1827:35:15"
            },
            "returnParameters": {
              "id": 2504,
              "nodeType": "ParameterList",
              "parameters": [],
              "src": "1872:0:15"
            },
            "scope": 2571,
            "src": "1806:755:15",
            "stateMutability": "nonpayable",
            "virtual": false,
            "visibility": "external"
          }
        ],
        "scope": 2572,
        "src": "281:2282:15",
        "usedErrors": []
      }
    ],
    "src": "32:2532:15"
  },
  "compiler": {
    "name": "solc",
    "version": "0.8.7+commit.e28d00a7.Emscripten.clang"
  },
  "networks": {
    "97": {
      "events": {},
      "links": {},
      "address": "0xe01DaDF3b1316e8B94d861f12c0199e27d29EA0e",
      "transactionHash": "0x6b5fc4133cb1f400ad36968af1808d46d7c595fa4cf16f30b903b540a746d94e"
    }
  },
  "schemaVersion": "3.4.3",
  "updatedAt": "2023-08-12T22:23:24.346Z",
  "networkType": "ethereum",
  "devdoc": {
    "kind": "dev",
    "methods": {
      "owner()": {
        "details": "Returns the address of the current owner."
      },
      "renounceOwnership()": {
        "details": "Leaves the contract without owner. It will not be possible to call `onlyOwner` functions anymore. Can only be called by the current owner. NOTE: Renouncing ownership will leave the contract without an owner, thereby removing any functionality that is only available to the owner."
      },
      "transferOwnership(address)": {
        "details": "Transfers ownership of the contract to a new account (`newOwner`). Can only be called by the current owner."
      }
    },
    "version": 1
  },
  "userdoc": {
    "kind": "user",
    "methods": {},
    "version": 1
  }
}